import moment from "moment";
import firebase from "../../app/config/firebase";
import axios from "../../axios-firebase";
import { saveAs } from "file-saver";
import format from "date-fns/format";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { closeModal } from "../modals/modalActions";
import { toastr } from "react-redux-toastr";
import {
  createReportExcelFile,
  createNewExcelFile,
} from "../../app/excel/excel";
import { createWeeklyMerchantSalesExcelFile } from "./Cachet/WeeklyMerchantSalesReport/excelReport";
import { isVisibleRecord } from "../../app/common/util/helpers";


import {
  FETCH_TRANSACTIONS,
  FETCH_RECON_TRANSACTIONS,
  FETCH_REPORTS,
} from "./reportConstants";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "../async/asyncActions";

export const getTransactionsForDashboard =
  (values) => async (dispatch, getState) => {
    const outletId =
      typeof values.outletId === "string"
        ? values.outletId
        : values.outletId.value;

    const reportStartDate = values.reportStartDate; // set to 12:00 am today
    const reportEndDate = values.reportEndDate; // set to 23:59 pm today

    console.log("reportStartDate", reportStartDate);
    console.log("reportEndDate", reportEndDate);

    const firestore = firebase.firestore();

    const transactionsRef = firestore.collection("transactions");
    const outletUsersRef = firestore.collection("outlet_users");

    try {
      dispatch(asyncActionStart());

      let query = transactionsRef
        .where("transactionDateTime", ">=", reportStartDate)
        .where("transactionDateTime", "<=", reportEndDate)
        .where("outletId", "==", outletId)
        .where("transactionType", "==", "Sale")
        .where("transactionStatus", "==", "Successful")
        .orderBy("transactionDateTime");

      let usersQuery = outletUsersRef.where("outletId", "==", outletId);

      let querySnap = await query.get();
      let usersQuerySnap = await usersQuery.get();

      let transactions = [];
      let users = [];

      if (querySnap.docs.length === 0) {
        dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
        dispatch(asyncActionFinish());
        return querySnap;
      }

      for (let i = 0; i < usersQuerySnap.docs.length; i++) {
        let user = {
          ...usersQuerySnap.docs[i].data(),
          id: usersQuerySnap.docs[i].id,
        };
        users.push(user);
      }

      for (let i = 0; i < querySnap.docs.length; i++) {
        let transaction = {
          ...querySnap.docs[i].data(),
          name: getUsersName(querySnap.docs[i].data().createdBy, users),
          id: querySnap.docs[i].id,
        };
        if (isVisibleRecord(transaction)) {
          transactions.push(transaction);
        }
      }
      console.log("users is ", users);

      dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const getReconTransactionsForDashboard =
  (values) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const reportStartDate = values.reportStartDate;
    const reportEndDate = values.reportEndDate;

    console.log("reportStartDate", reportStartDate);
    console.log("reportEndDate", reportEndDate);

    // const firestore = firebase.firestore();

    // const transactionsRef = firestore.collection("merchant_balance");

    try {
      dispatch(asyncActionStart());

      // const depositsByDepositDate = await firestore
      //   .collection("merchant_balance")
      //   .where("dateOfDeposit", ">=", reportStartDate)
      //   .where("dateOfDeposit", "<=", reportEndDate)
      //   .where("transactionType", "==", "Deposit")
      //   .orderBy("dateOfDeposit")
      //   .get()
      //   .then(async (querySnapshot) => {
      //     if (querySnapshot.size > 0) {
      //       let balances = [];

      //       for (let i = 0; i < querySnapshot.docs.length; i++) {
      //         let transaction = {
      //           ...querySnapshot.docs[i].data(),
      //           id: querySnapshot.docs[i].id,
      //         };

      //         balances.push(transaction);
      //       }

      //       return {
      //         depositsByDepositDateTotal: balances
      //           .filter((item) => item.transactionType === "Deposit")
      //           .reduce(function (total, doc) {
      //             total += parseFloat(doc.transactionAmount)
      //               ? parseFloat(doc.transactionAmount)
      //               : 0;

      //             return total;
      //           }, 0),
      //         depositsByDepositDateList: balances
      //           .filter((item) => item.transactionType === "Deposit")
      //           .map((doc) => {
      //             return {
      //               bank: doc.bank,
      //               createdBy: doc.createdBy,
      //               account: doc.account,
      //               merchantName: doc.merchantName,
      //               dateOfDeposit: doc.dateOfDeposit
      //                 ? doc.dateOfDeposit.toDate()
      //                 : doc.transactionDateTime.toDate(),
      //               depositMethod: doc.depositMethod,
      //               transactionAmount: doc.transactionAmount,
      //               transactionDateTime: doc.transactionDateTime.toDate(),
      //             };
      //           }),
      //       };
      //     } else {
      //       let response = {
      //         depositsByDepositDateTotal: 0,
      //         depositsByDepositDateList: [],
      //       };
      //       return response;
      //     }
      //   });

      let response = await axios
        .post("api/vendorRecon", {
          reportStartDate: values.reportStartDate,
          reportEndDate: values.reportEndDate,
        })
        .then((response) => {
          return response;
        });

      const transactions = response.data;

      // transactions.depositsByDepositDateTotal =
      //   depositsByDepositDate.depositsByDepositDateTotal;
      // transactions.depositsByDepositDateList =
      //   depositsByDepositDate.depositsByDepositDateList;

      console.log("transactions", transactions);

      dispatch({ type: FETCH_RECON_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(asyncActionError());
    }
  };

export const getReconTransactionsForExport = (values) => async (dispatch) => {
  const reportStartDate = values.reportStartDate;
  const reportEndDate = values.reportEndDate;

  try {
    dispatch(asyncActionStart());

    const reportName = "Merchant Financials";
    const now = Date.now();

    await axios
      .post("api/vendorReconExcel", {
        reportStartDate: reportStartDate,
        reportEndDate: reportEndDate,
      })
      .then((response) => {
        let buff = new Buffer(response.data.base64, "base64");

        const blob = new Blob([buff], { type: "application/octet-stream" });
        saveAs(blob, `${reportName}-${now}.xlsx`);
      });

    dispatch(closeModal());

    dispatch(asyncActionFinish());
  } catch (error) {
    if (error) {
      console.log(error);
    }
    dispatch(closeModal());
    dispatch(asyncActionError());
  }
};

export const getBPCDailySalesForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "BPC Daily Sales";

      await axios
        .post("reports-onDemandBPCDailyReports", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          console.log("base64", response);
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getOozeDailySalesForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Ooze Daily Sales";

      await axios
        .post("reports-oozeOnDemandExcelReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getKazangDailySalesForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Kazang Daily Sales";

      await axios
        .post("reports-kazangOnDemandExcelReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getCustomerDailySalesForExport =
  (account, reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Customer Report Sales";

      await axios
        .post("reports-customerITReportExcel", {
          account: account,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getBPCReversalsForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "BPC Reversals";

      await axios
        .post("reports-BPCReversalsOnDemand", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getReversalTransactionsForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Reversals";

      await axios
        .post("api/reversalReportExcel", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          console.log("response", response);

          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getChoppiesMonthlyTransactionsForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const dateFormat = "YYYY-MM-DD";

    const startDate = moment(reportStartDate).format(dateFormat);
    const endDate = moment(reportEndDate).format(dateFormat);

    const month = moment(reportStartDate).format("MMM");

    // console.log("startDate", startDate);
    // console.log("endDate", endDate);
    // console.log("month", month);

    try {
      dispatch(asyncActionStart());

      const reportName = "Choppies Monthly Report";

      await axios
        .post("reports-choppiesMonthlyMerchantReportExcel", {
          reportStartDate: startDate,
          reportEndDate: endDate,
        })
        .then((response) => {
          console.log("response", response);

          let buff = new Buffer(response.data.base64, "base64");

          // let buff = new Buffer.from(response.data.base64, "base64");
          console.log("buff", buff);

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${month}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getSalesAndCommissionForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "BPC Daily Sales";

      await axios
        .post("reports-merchantsSalesBreakdownReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getDeviceTransactionsForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Device Transactions";

      await axios
        .post("reports-merchantDeviceTransactionReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getMerchantContractDepositsForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "Merchant Deposits";

      await axios
        .post("reports-merchantContractDepositsReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getMerchantActivityReportForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();
    try {
      dispatch(asyncActionStart());

      const reportName = "Merchant Activity";

      await axios
        .post( 
          "reports-merchantActivityReport",
          {
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
          }
        )
        .then((response) => {
          console.log("Response:", response);

          let buff = Buffer.from(response.data.file, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };


  export const getReferralProgrammeReportForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();
    try {
      dispatch(asyncActionStart());

      const reportName = "Referral Programme";

      await axios
        .post( 
          "reports-referralProgrammeReport",
          {
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
          }
        )
        .then((response) => {
          console.log("Response:", response);

          let buff = Buffer.from(response.data.file, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getGroupSalesAndCommissionForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "BPC Daily Sales";

      await axios
        .post("reports-groupSalesBreakdownReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const getChoppiesSalesAndCommissionForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    const now = Date.now();

    try {
      dispatch(asyncActionStart());

      const reportName = "BPC Daily Sales";

      await axios
        .post("reports-choppiesSalesBreakdownReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
        .then((response) => {
          let buff = new Buffer(response.data.base64, "base64");

          const blob = new Blob([buff], { type: "application/octet-stream" });
          saveAs(blob, `${reportName}-${now}.xlsx`);
        });

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        // console.log(error);
      }
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

async function fetchReportData(reportSection, reportStartDate, reportEndDate) {
  try {
    let limit = 90000;
    let startAfter = "";
    let canContinue = true;
    if (reportSection == "sales") {
      let _sales = {};
      //sales looping logic
      while (canContinue) {
        const response = await axios.post("reports-cachetFinancialsReport", {
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
          reportSection: reportSection,
          limit: limit,
          startAfter: startAfter,
        });
        if (response.status != 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        function mergeAndSumObjects(obj1, obj2) {
          // Helper function to check if a value is an object
          function isObject(value) {
            return value && typeof value === "object" && !Array.isArray(value);
          }

          function mergeRecursive(obj1, obj2) {
            const result = {};

            const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

            for (const key of keys) {
              const val1 = obj1[key];
              const val2 = obj2[key];

              if (isObject(val1) || isObject(val2)) {
                result[key] = mergeRecursive(val1 || {}, val2 || {});
              } else {
                result[key] = (val1 || 0) + (val2 || 0);
              }
            }

            return result;
          }
          return mergeRecursive(obj1, obj2);
        }
        if (response.data.sales.count > 0) {
          // console.log(_sales);
          startAfter = response.data.startAfter;
          if (startAfter == null) {
            canContinue = false;
          }
          _sales = mergeAndSumObjects(_sales, response.data);
        } else {
          canContinue = false;
        }
      }
      return _sales;
    } else {
      const response = await axios.post("reports-cachetFinancialsReport", {
        reportStartDate: reportStartDate,
        reportEndDate: reportEndDate,
        reportSection: reportSection,
      });
      if (response.status != 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.data;
    }
  } catch (e) {
    throw e;
  }
}

export const getFinancialsReportForExport =
  (reportStartDate, reportEndDate) => async (dispatch) => {
    try {
      dispatch(asyncActionStart());

      let openingBalance,
        closingBalance,
        deposits,
        commissions,
        reversals,
        sales,
        withdraws,
        contracts;

      let sections = [
        "openingBalance",
        "closingBalance",
        "deposits",
        "commissions",
        "reversals",
        "sales",
        "withdraws",
        "contracts",
      ];

      const reportName = `Financials Report `;

      const promises = sections.map((section) =>
        fetchReportData(section, reportStartDate, reportEndDate)
      );

      const results = await Promise.all(promises);

      results.forEach((result, index) => {
        if (index == 0) {
          openingBalance = result;
          // console.log(`openingBalance: `, result);
        } else if (index == 1) {
          closingBalance = result;
          // console.log(`closingBalance: `, result);
        } else if (index == 2) {
          deposits = result;
          // console.log(`deposits: `, result);
        } else if (index == 3) {
          commissions = result;
          // console.log(`commissions: `, result);
        } else if (index == 4) {
          reversals = result;
          // console.log(`reversals: `, result);
        } else if (index == 5) {
          sales = result;
          // console.log(`sales: `, result);
        } else if (index == 6) {
          withdraws = result;
          // console.log(`withdraws: `, result);
        } else if (index == 7) {
          contracts = result;
          // console.log(`contracts: `, result);
        }
      });

      let valueSections = {
        openingBalance: openingBalance,
        closingBalance: closingBalance,
        deposits: deposits,
        commissions: commissions,
        reversals: reversals,
        sales: sales,
        withdraws: withdraws,
        contracts: contracts,
      };

      // console.log(valueSections);

      let financialsreportSheet = async (
        valueSections,
        workbook,
        logo,
        accountName
      ) => {
        let summarysheet = workbook.addWorksheet("Financials summary", {
          properties: {
            showGridLines: false,
          },
          pageSetup: {
            paperSize: 9,
            fitToPage: true,
            orientation: "portrait",
          },
          views: [
            {
              state: "frozen",
              xSplit: 5,
              activeCell: "A1",
              showGridLines: false,
            },
          ],
        });

        let commissionsheet = workbook.addWorksheet("Commissions", {
          properties: {
            showGridLines: false,
            defaultColWidth: 100,
          },
          pageSetup: {
            paperSize: 9,
            fitToPage: true,
            orientation: "portrait",
          },
          views: [
            {
              state: "frozen",
              xSplit: 6,
              activeCell: "A1",
              showGridLines: false,
            },
          ],
        });

        let depositsheet = workbook.addWorksheet("Deposits", {
          properties: {
            showGridLines: false,
          },
          pageSetup: {
            paperSize: 9,
            fitToPage: true,
            orientation: "portrait",
          },
          views: [
            {
              state: "frozen",
              xSplit: 15,
              activeCell: "A1",
              showGridLines: false,
            },
          ],
        });

        depositsheet.mergeCells("A6", "E6");
        depositsheet.getCell("A6").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Deposits",
            },
          ],
        };

        depositsheet.mergeCells("A1", "G2");
        depositsheet.addImage(logo, {
          tl: {
            col: 0.25,
            row: 0.25,
          },
          ext: {
            width: 150,
            height: 32,
          },
        });

        depositsheet.mergeCells("A4", "G4");
        depositsheet.getCell("A4").value = {
          richText: [
            {
              font: {
                size: 14,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Prepaidplus Financials Report",
            },
          ],
        };

        depositsheet.getColumn(1).width = 25;
        depositsheet.getColumn(2).width = 25;
        depositsheet.getColumn(3).width = 25;
        depositsheet.getColumn(4).width = 25;
        depositsheet.getColumn(5).width = 25;
        depositsheet.getColumn(6).width = 25;
        depositsheet.getColumn(7).width = 25;

        depositsheet.getCell("G8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };

        ["A8", "B8", "C8", "D8", "E8", "F8", "G8"].map((key) => {
          depositsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        depositsheet.getCell("A8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Account",
            },
          ],
        };
        depositsheet.getCell("B8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Merchant name",
            },
          ],
        };
        depositsheet.getCell("C8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Deposit by",
            },
          ],
        };

        depositsheet.getCell("D8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Transation date",
            },
          ],
        };
        depositsheet.getCell("E8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Bank",
            },
          ],
        };
        depositsheet.getCell("F8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Bank Deposit date",
            },
          ],
        };
        depositsheet.getCell("G8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Amount",
            },
          ],
        };

        let _index_depositsheet = 8;

        for (const element in valueSections["deposits"].records) {
          let transactionDateTime =
            valueSections["deposits"].records[element].transactionDateTime;

          // Convert _seconds to milliseconds
          let milliseconds = transactionDateTime._seconds * 1000;

          // Convert _nanoseconds to milliseconds
          let additionalMilliseconds =
            transactionDateTime._nanoseconds / 1000000;

          // Total milliseconds since Unix epoch
          let totalMilliseconds = milliseconds + additionalMilliseconds;

          // Create a Moment.js date object
          let date = moment(totalMilliseconds);
          depositsheet.getCell(`A${1 + _index_depositsheet}`).value =
            valueSections["deposits"].records[element].account;

          depositsheet.getCell(`B${1 + _index_depositsheet}`).value =
            valueSections["deposits"].records[element].merchantName;

          depositsheet.getCell(`C${1 + _index_depositsheet}`).value =
            valueSections["deposits"].records[element].createdBy;

          depositsheet.getCell(`D${1 + _index_depositsheet}`).value =
            date.format();

          depositsheet.getCell(`E${1 + _index_depositsheet}`).value =
            valueSections["deposits"].records[element].bank;

          transactionDateTime =
            valueSections["deposits"].records[element].dateOfDeposit;
          // Convert _seconds to milliseconds
          milliseconds = transactionDateTime._seconds * 1000;

          // Convert _nanoseconds to milliseconds
          additionalMilliseconds = transactionDateTime._nanoseconds / 1000000;

          // Total milliseconds since Unix epoch
          totalMilliseconds = milliseconds + additionalMilliseconds;

          // Create a Moment.js date object
          date = moment(totalMilliseconds);

          depositsheet.getCell(`F${1 + _index_depositsheet}`).value = format(
            date.toDate(),
            "DD-MM-YYYY"
          );

          depositsheet.getCell(`G${1 + _index_depositsheet}`).value =
            valueSections["deposits"].records[element].transactionAmount;

          _index_depositsheet++;
        }

        //////here//////

        let reversalsheet = workbook.addWorksheet("Reversals", {
          properties: {
            showGridLines: false,
          },
          pageSetup: {
            paperSize: 9,
            fitToPage: true,
            orientation: "portrait",
          },
          views: [
            {
              state: "frozen",
              xSplit: 15,
              activeCell: "A1",
              showGridLines: false,
            },
          ],
        });

        reversalsheet.mergeCells("A6", "E6");
        reversalsheet.getCell("A6").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Reversals",
            },
          ],
        };

        reversalsheet.mergeCells("A1", "G2");
        reversalsheet.addImage(logo, {
          tl: {
            col: 0.25,
            row: 0.25,
          },
          ext: {
            width: 150,
            height: 32,
          },
        });

        reversalsheet.mergeCells("A4", "G4");
        reversalsheet.getCell("A4").value = {
          richText: [
            {
              font: {
                size: 14,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Prepaidplus Financials Report",
            },
          ],
        };

        reversalsheet.getColumn(1).width = 25;
        reversalsheet.getColumn(2).width = 25;
        reversalsheet.getColumn(3).width = 25;
        reversalsheet.getColumn(4).width = 25;
        reversalsheet.getColumn(5).width = 25;
        reversalsheet.getColumn(6).width = 25;
        reversalsheet.getColumn(7).width = 25;
        reversalsheet.getColumn(8).width = 25;

        reversalsheet.getCell("H8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };

        ["A8", "B8", "C8", "D8", "E8", "F8", "G8", "H8"].map((key) => {
          reversalsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        reversalsheet.getCell("A8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Account",
            },
          ],
        };
        reversalsheet.getCell("B8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Merchant name",
            },
          ],
        };
        reversalsheet.getCell("C8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Reversed by",
            },
          ],
        };

        reversalsheet.getCell("D8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Transation date",
            },
          ],
        };
        reversalsheet.getCell("E8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Type",
            },
          ],
        };
        reversalsheet.getCell("F8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Reason",
            },
          ],
        };
        reversalsheet.getCell("G8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Original Transaction",
            },
          ],
        };
        reversalsheet.getCell("H8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Amount",
            },
          ],
        };

        let _index_reversalsheet = 8;

        for (const element in valueSections["reversals"].records) {
          let transactionDateTime =
            valueSections["reversals"].records[element].transactionDateTime;
          let milliseconds = transactionDateTime._seconds * 1000;
          let additionalMilliseconds =
            transactionDateTime._nanoseconds / 1000000;
          let totalMilliseconds = milliseconds + additionalMilliseconds;
          let date = moment(totalMilliseconds);

          reversalsheet.getCell(`A${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].account;

          reversalsheet.getCell(`B${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].merchantName;

          reversalsheet.getCell(`C${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].createdBy;

          reversalsheet.getCell(`D${1 + _index_reversalsheet}`).value =
            date.format();

          reversalsheet.getCell(`E${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].reversalType;

          reversalsheet.getCell(`F${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].reversalReason;

          reversalsheet.getCell(`G${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].reference;

          reversalsheet.getCell(`H${1 + _index_reversalsheet}`).value =
            valueSections["reversals"].records[element].transactionAmount;
          _index_reversalsheet++;
        }

        //////here//////

        /////////////////////////
        let withdrawalsheet = workbook.addWorksheet("Withdrawals", {
          properties: {
            showGridLines: false,
          },
          pageSetup: {
            paperSize: 9,
            fitToPage: true,
            orientation: "portrait",
          },
          views: [
            {
              state: "frozen",
              xSplit: 15,
              activeCell: "A1",
              showGridLines: false,
            },
          ],
        });

        withdrawalsheet.mergeCells("A6", "E6");
        withdrawalsheet.getCell("A6").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Withdrawals",
            },
          ],
        };

        withdrawalsheet.mergeCells("A1", "G2");
        withdrawalsheet.addImage(logo, {
          tl: {
            col: 0.25,
            row: 0.25,
          },
          ext: {
            width: 150,
            height: 32,
          },
        });

        withdrawalsheet.mergeCells("A4", "G4");
        withdrawalsheet.getCell("A4").value = {
          richText: [
            {
              font: {
                size: 14,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Prepaidplus Financials Report",
            },
          ],
        };

        withdrawalsheet.getColumn(1).width = 25;
        withdrawalsheet.getColumn(2).width = 25;
        withdrawalsheet.getColumn(3).width = 25;
        withdrawalsheet.getColumn(4).width = 25;
        withdrawalsheet.getColumn(5).width = 25;
        withdrawalsheet.getColumn(6).width = 25;
        withdrawalsheet.getColumn(7).width = 25;

        withdrawalsheet.getCell("G8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };

        ["A8", "B8", "C8", "D8", "E8", "F8", "G8"].map((key) => {
          withdrawalsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        withdrawalsheet.getCell("A8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Account",
            },
          ],
        };
        withdrawalsheet.getCell("B8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Merchant name",
            },
          ],
        };
        withdrawalsheet.getCell("C8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Recorded by",
            },
          ],
        };

        withdrawalsheet.getCell("D8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Bank",
            },
          ],
        };
        withdrawalsheet.getCell("E8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Transaction date",
            },
          ],
        };
        withdrawalsheet.getCell("F8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Reason",
            },
          ],
        };
        withdrawalsheet.getCell("G8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Amount",
            },
          ],
        };

        let _index_withdrawalsheet = 8;

        for (const element in valueSections["withdraws"].records) {
          let transactionDateTime =
            valueSections["withdraws"].records[element].transactionDateTime;
          let milliseconds = transactionDateTime._seconds * 1000;
          let additionalMilliseconds =
            transactionDateTime._nanoseconds / 1000000;
          let totalMilliseconds = milliseconds + additionalMilliseconds;
          let date = moment(totalMilliseconds);

          withdrawalsheet.getCell(`A${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].account;

          withdrawalsheet.getCell(`B${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].merchantName;

          withdrawalsheet.getCell(`C${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].createdBy;

          withdrawalsheet.getCell(`D${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].withdrawalFromBank;

          withdrawalsheet.getCell(`E${1 + _index_withdrawalsheet}`).value =
            date.format();

          withdrawalsheet.getCell(`F${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].withdrawalReason;

          withdrawalsheet.getCell(`G${1 + _index_withdrawalsheet}`).value =
            valueSections["withdraws"].records[element].transactionAmount;

          _index_withdrawalsheet++;
        }

        //////here//////
        /////////////////////////

        summarysheet.mergeCells("A1", "G2");
        summarysheet.addImage(logo, {
          tl: {
            col: 0.25,
            row: 0.25,
          },
          ext: {
            width: 150,
            height: 32,
          },
        });

        summarysheet.mergeCells("A4", "G4");
        summarysheet.getCell("A4").value = {
          richText: [
            {
              font: {
                size: 14,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Prepaidplus Financials Report",
            },
          ],
        };

        commissionsheet.mergeCells("A1", "G2");
        commissionsheet.addImage(logo, {
          tl: {
            col: 0.25,
            row: 0.25,
          },
          ext: {
            width: 150,
            height: 32,
          },
        });

        commissionsheet.mergeCells("A4", "G4");
        commissionsheet.getCell("A4").value = {
          richText: [
            {
              font: {
                size: 14,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Prepaidplus Financials Report",
            },
          ],
        };

        summarysheet.mergeCells("A6", "B6");
        summarysheet.getCell("A6").value = {
          richText: [
            {
              font: {
                size: 13,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Start date: ",
            },
          ],
        };

        summarysheet.mergeCells("A7", "B7");
        summarysheet.getCell("A7").value = {
          richText: [
            {
              font: {
                size: 13,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "End date: ",
            },
          ],
        };

        summarysheet.mergeCells("C6", "E6");
        summarysheet.getCell("C6").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: reportStartDate.toString().split("GMT")[0],
            },
          ],
        };

        summarysheet.mergeCells("C7", "E7");
        summarysheet.getCell("C7").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: reportEndDate.toString().split("GMT")[0],
            },
          ],
        };

        ["A10", "B10", "C10", "D10", "E10"].map((key) => {
          summarysheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        summarysheet.mergeCells("A10", "D10");
        summarysheet.getCell("A10").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },
              text: "Type",
            },
          ],
        };

        // summarysheet.mergeCells("E10", "G10");
        summarysheet.getCell("E10").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Amount",
            },
          ],
        };

        summarysheet.mergeCells("A11", "C11");
        summarysheet.getCell("A11").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Starting Balance",
            },
          ],
        };

        // summarysheet.mergeCells("E11", "G11");
        summarysheet.getCell("E11").value =
          valueSections["openingBalance"].openingBalance;
        summarysheet.getCell("E11").font = {
          size: 11,
          color: {
            argb: "FF000000",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };

        summarysheet.mergeCells("A12", "C12");
        summarysheet.getCell("A12").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Deposits",
            },
          ],
        };

        // summarysheet.mergeCells("E12", "G12");
        summarysheet.getCell("E12").value = valueSections["deposits"].total;

        summarysheet.mergeCells("A13", "C13");
        summarysheet.getCell("A13").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Creddited Commissions",
            },
          ],
        };

        // summarysheet.mergeCells("E13", "G13");
        summarysheet.getCell("E13").value = valueSections["commissions"].total;

        summarysheet.mergeCells("A14", "C14");
        summarysheet.getCell("A14").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Reversals",
            },
          ],
        };

        // summarysheet.mergeCells("E14", "G14");
        summarysheet.getCell("E14").value = valueSections["reversals"].total;

        ////commissions
        commissionsheet.mergeCells("A6", "E6");
        commissionsheet.getCell("A6").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned commissions",
            },
          ],
        };

        summarysheet.getCell("E10").alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getColumn(1).width = 25;
        commissionsheet.getColumn(2).width = 25;
        commissionsheet.getColumn(3).width = 25;
        commissionsheet.getColumn(4).width = 25;
        commissionsheet.getColumn(5).width = 25;
        commissionsheet.getColumn(6).width = 25;
        commissionsheet.getCell("C8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell("D8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell("E8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell("F8").alignment = {
          vertical: "middle",
          horizontal: "right",
        };

        ["A8", "B8", "C8", "D8", "E8", "F8"].map((key) => {
          commissionsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        commissionsheet.getCell("A8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Type",
            },
          ],
        };
        commissionsheet.getCell("B8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Provider",
            },
          ],
        };
        commissionsheet.getCell("C8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Total sales",
            },
          ],
        };

        commissionsheet.getCell("D8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Prepaidplus",
            },
          ],
        };
        commissionsheet.getCell("E8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Merchants",
            },
          ],
        };
        commissionsheet.getCell("F8").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Net Commission",
            },
          ],
        };

        // console.log(valueSections["sales"].sales.byProvider);
        let _index_commissionsheet = 0;
        for (const element in valueSections["sales"].commissions.prepaid
          .byProvider) {
          commissionsheet.getCell(`A${9 + _index_commissionsheet}`).value =
            element == "Botswana Power Corporation"
              ? "Electricity"
              : element.trim() == "Orange Voucher"
              ? "Airtime"
              : element.trim() == "Orange Pinless"
              ? "Airtime"
              : element.trim() == "Mascom Voucher"
              ? "Airtime"
              : element.trim() == "Mascom Pinless"
              ? "Airtime"
              : element.trim() == "beMobile Voucher"
              ? "Airtime"
              : element.trim() == "beMobile Pinless"
              ? "Airtime"
              : element.trim() == "MultiChoice Botswana"
              ? "DSTV"
              : null;

          commissionsheet.getCell(`B${9 + _index_commissionsheet}`).value =
            element;

          commissionsheet.getCell(`C${9 + _index_commissionsheet}`).value =
            valueSections["sales"].sales.byProvider[element];

          commissionsheet.getCell(`D${9 + _index_commissionsheet}`).value =
            valueSections["sales"].commissions.prepaid.byProvider[element];

          commissionsheet.getCell(`E${9 + _index_commissionsheet}`).value =
            valueSections["sales"].commissions.merchants.byProvider[element];

          commissionsheet.getCell(`F${9 + _index_commissionsheet}`).value =
            valueSections["sales"].commissions.prepaid.byProvider[element] -
            valueSections["sales"].commissions.merchants.byProvider[element];

          _index_commissionsheet++;
        }
        ////
        _index_commissionsheet = _index_commissionsheet + 9;
        commissionsheet.getCell(`C${_index_commissionsheet}`).value =
          valueSections["sales"].sales.total;
        commissionsheet.getCell(`C${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`D${_index_commissionsheet}`).value =
          valueSections["sales"].commissions.prepaid.total;

        commissionsheet.getCell(`D${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`E${_index_commissionsheet}`).value =
          valueSections["sales"].commissions.merchants.total;
        commissionsheet.getCell(`E${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`F${_index_commissionsheet}`).value =
          valueSections["sales"].commissions.net;

        commissionsheet.getCell(`F${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        [
          `A${_index_commissionsheet}`,
          `B${_index_commissionsheet}`,
          `C${_index_commissionsheet}`,
          `D${_index_commissionsheet}`,
          `E${_index_commissionsheet}`,
          `F${_index_commissionsheet}`,
        ].map((key) => {
          commissionsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        /**
         *
         */
        _index_commissionsheet = _index_commissionsheet + 4;

        commissionsheet.mergeCells(
          `A${_index_commissionsheet}`,
          `C${_index_commissionsheet}`
        );
        commissionsheet.getCell(`A${_index_commissionsheet}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Credited commissions",
            },
          ],
        };
        _index_commissionsheet = _index_commissionsheet + 1;

        commissionsheet.getCell(`C${_index_commissionsheet + 1}`).alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell(`D${_index_commissionsheet + 1}`).alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell(`E${_index_commissionsheet + 1}`).alignment = {
          vertical: "middle",
          horizontal: "right",
        };
        commissionsheet.getCell(`F${_index_commissionsheet + 1}`).alignment = {
          vertical: "middle",
          horizontal: "right",
        };

        [
          `A${_index_commissionsheet + 1}`,
          `B${_index_commissionsheet + 1}`,
          `C${_index_commissionsheet + 1}`,
          `D${_index_commissionsheet + 1}`,
          `E${_index_commissionsheet + 1}`,
          `F${_index_commissionsheet + 1}`,
        ].map((key) => {
          commissionsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        commissionsheet.getCell(`A${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Type",
            },
          ],
        };
        commissionsheet.getCell(`B${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Provider",
            },
          ],
        };
        commissionsheet.getCell(`C${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Total sales",
            },
          ],
        };

        commissionsheet.getCell(`D${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Prepaidplus",
            },
          ],
        };
        commissionsheet.getCell(`E${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Merchants",
            },
          ],
        };
        commissionsheet.getCell(`F${_index_commissionsheet + 1}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FFFFFFFF",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Net Commission",
            },
          ],
        };

        _index_commissionsheet = _index_commissionsheet + 1;

        for (const element in valueSections["commissions"].byProvider) {
          commissionsheet.getCell(`A${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].type;

          commissionsheet.getCell(`B${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].provider;

          commissionsheet.getCell(`C${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].total;

          commissionsheet.getCell(`D${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].ppp;

          commissionsheet.getCell(`E${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].merchant;

          commissionsheet.getCell(`F${1 + _index_commissionsheet}`).value =
            valueSections["commissions"].byProvider[element].ppp -
            valueSections["commissions"].byProvider[element].merchant;

          _index_commissionsheet++;
        }
        ////
        _index_commissionsheet = _index_commissionsheet + 1;
        commissionsheet.getCell(`C${_index_commissionsheet}`).value =
          valueSections["commissions"].total;
        commissionsheet.getCell(`C${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`D${_index_commissionsheet}`).value =
          valueSections["commissions"].ppp;

        commissionsheet.getCell(`D${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`E${_index_commissionsheet}`).value =
          valueSections["commissions"].merchant;
        commissionsheet.getCell(`E${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        commissionsheet.getCell(`F${_index_commissionsheet}`).value =
          valueSections["commissions"].ppp -
          valueSections["commissions"].merchant;

        commissionsheet.getCell(`F${_index_commissionsheet}`).font = {
          size: 12,
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
        [
          `A${_index_commissionsheet}`,
          `B${_index_commissionsheet}`,
          `C${_index_commissionsheet}`,
          `D${_index_commissionsheet}`,
          `E${_index_commissionsheet}`,
          `F${_index_commissionsheet}`,
        ].map((key) => {
          commissionsheet.getCell(key).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF002060",
            },
          };
        });

        /**
         *
         */

        summarysheet.mergeCells("A16", "C16");
        summarysheet.getCell("A16").value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Sales",
            },
          ],
        };

        // console.log(valueSections["sales"].sales.byProvider);
        let _index = 0;
        for (const element in valueSections["sales"].sales.byProvider) {
          summarysheet.mergeCells(`A${17 + _index}`, `C${17 + _index}`);
          // summarysheet.mergeCells(`E${17 + _index}`, `G${17 + _index}`);

          summarysheet.getCell(`A${17 + _index}`).value = element;

          summarysheet.getCell(`E${17 + _index}`).value =
            valueSections["sales"].sales.byProvider[element];

          _index++;
        }

        _index = _index + 17;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Total Sales",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["sales"].sales.total;
        summarysheet.getCell(`E${_index}`).font = {
          size: 11,
          color: {
            argb: "FF000000",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };

        _index = _index + 2;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Withdrawals",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["withdraws"].total;

        //add device contracts here
        for (const element in valueSections["contracts"].byProvider) {
          _index++;
          summarysheet.mergeCells(`A${_index}`, `C${_index}`);
          // summarysheet.mergeCells(`E${_index}`, `G${_index}`);

          summarysheet.getCell(
            `A${_index}`
          ).value = `Device contract - ${element}`;

          summarysheet.getCell(`E${_index}`).value =
            valueSections["contracts"].byProvider[element];
        }

        _index = _index + 1;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Closing Balance",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["closingBalance"].closingBalance;
        summarysheet.getCell(`E${_index}`).font = {
          size: 11,
          color: {
            argb: "FF000000",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };

        _index = _index + 2;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Commissions",
            },
          ],
        };

        _index = _index + 1;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Prepaidplus",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["sales"].commissions.prepaid.total;

        _index = _index + 1;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: false,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Earned by Merchants",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["sales"].commissions.merchants.total;

        _index = _index + 1;
        summarysheet.mergeCells(`A${_index}`, `C${_index}`);
        summarysheet.getCell(`A${_index}`).value = {
          richText: [
            {
              font: {
                size: 12,
                color: {
                  argb: "FF000000",
                },
                bold: true,
                name: "Calibri",
                family: 4,
                scheme: "minor",
              },

              text: "Net commission",
            },
          ],
        };

        // summarysheet.mergeCells(`E${_index}`, `G${_index}`);
        summarysheet.getCell(`E${_index}`).value =
          valueSections["sales"].commissions.net;
        summarysheet.getCell(`E${_index}`).font = {
          size: 11,
          color: {
            argb: "FF000000",
          },
          bold: true,
          name: "Calibri",
          family: 4,
          scheme: "minor",
        };
      };

      createNewExcelFile(
        reportName,
        valueSections,
        financialsreportSheet,
        "Financials Report"
      );

      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        // console.log(error);
      }
      toastr.error("Oops", "Something went wrong");
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

export const canDownloadTransactionReceipt = (transaction) => {
  const providers = [
    "Botswana Power Corporation",
    "MultiChoice Botswana",
    "Mascom Pinless",
    "Orange Pinless",
    "beMobile Pinless",
    "Gambling",
    "Myzaka cashin",
    "Myzaka cashout",
    "Badiphitlho",
    "Botswana Life",
  ];

  return (
    transaction.transactionType === "Sale" &&
    transaction.transactionStatus === "Successful" &&
    (providers.includes(transaction.provider) ||
      /^(Mascom|Orange|beMobile)-\d+$/.test(transaction.provider))
  );
};

export const downloadTransactionReceipt = (transaction) => {
  if (!canDownloadTransactionReceipt(transaction)) {
    return;
  }

  try {
    const response = transaction.response;
    const date = moment(transaction.transactionDateTime.toDate()).utcOffset(
      120
    );
    const doc = new jsPDF();
    const isElectricity = transaction.provider === "Botswana Power Corporation";
    const margin = (doc.internal.pageSize.width - 82) / 2;

    function addRow(rows, label, value) {
      if (value !== undefined && value !== null && value !== "") {
        rows.push([label, "", String(value)]);
      }
    }

    function money(value) {
      if (value === undefined || value === null || value === "") {
        return undefined;
      }
      return Number(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function payment(value) {
      const amount = money(value);
      return amount === undefined ? undefined : `P${amount}`;
    }

    function addTable(body, startY, head) {
      autoTable(doc, {
        theme: "plain",
        startY: startY,
        tableWidth: 76,
        margin: { left: margin, right: margin, top: 15, bottom: 20 },
        headStyles: { fontSize: 10, fontStyle: "bold" },
        bodyStyles: { fontSize: 10, fontStyle: "normal" },
        styles: { cellPadding: 0.5, overflow: "linebreak" },
        columnStyles: { 2: { halign: "right" } },
        head: head
          ? [
              head.length === 1
                ? [
                    {
                      content: head[0],
                      colSpan: 3,
                      styles: { halign: "center" },
                    },
                  ]
                : head,
            ]
          : [],
        body: body,
        rowPageBreak: "avoid",
      });
    }

    if (isElectricity) {
      const dom = require("xmldom").DOMParser;
      const xml = new dom().parseFromString(response, "text/xml");

      function elements(parent, name) {
        return Array.from(parent.getElementsByTagName("*")).filter(
          (element) => element.nodeName.split(":").pop() === name
        );
      }

      function attribute(parent, name, key) {
        const element = elements(parent, name)[0];
        return element ? element.getAttribute(key) : undefined;
      }

      function text(parent, name) {
        const element = elements(parent, name)[0];
        return element ? element.textContent : undefined;
      }

      // Same fields produced by electricitySale.formatSuccessForReturn for self-service.
      const receipt = {
        clientId: attribute(xml, "clientID", "ean"),
        account: attribute(xml, "custVendDetail", "accNo"),
        location: attribute(xml, "custVendDetail", "locRef"),
        name: attribute(xml, "custVendDetail", "name"),
        receiptNo: attribute(xml, "creditVendReceipt", "receiptNo"),
        amtTendered: attribute(xml, "tenderAmt", "value"),
      };
      const keyChangeTokens = [];
      elements(xml, "tx").forEach((tx) => {
        if (tx.getAttribute("xsi:type") === "CreditVendTx") {
          const token = text(tx, "stsCipher");
          if (tx.hasAttribute("receiptNo")) {
            receipt.costUnits = attribute(tx, "amt", "value");
            receipt.tariff = text(tx, "name");
            const units = attribute(tx, "units", "value");
            const unit = attribute(tx, "units", "siUnit");
            receipt.tokenUnits = units ? `${units}${unit || ""}` : units;
            receipt.meterNumber = attribute(tx, "meterDetail", "msno");
            receipt.meterType = attribute(tx, "meterType", "tt");
            receipt.krn = attribute(tx, "meterDetail", "krn");
            receipt.ti = attribute(tx, "meterDetail", "ti");
            receipt.sgc = attribute(tx, "meterDetail", "sgc");
            receipt.stsCipher = token;
          } else if (token) {
            keyChangeTokens.push(token);
          }
        } else if (tx.getAttribute("xsi:type") === "ServiceChrgTx") {
          const amount = attribute(tx, "amt", "value");
          switch (text(tx, "accDesc")) {
            case "VAT":
              receipt.vat = amount;
              break;
            case "Standard Domestic Charge":
            case "Standard Business Charge":
              receipt.standardCharge = amount;
              break;
            case "Government Levy":
              receipt.governmentLevy = amount;
              break;
            default:
              break;
          }
        }
      });

      // BPC header verified against the self-service ELECTRICITY provider record.
      autoTable(doc, {
        theme: "plain",
        headStyles: { fontSize: 14, fontStyle: "bold", halign: "left" },
        bodyStyles: { fontSize: 10, fontStyle: "normal", cellWidth: "auto" },
        styles: { cellPadding: 0.5 },
        columnStyles: {
          0: { halign: "left" },
          2: { halign: "left" },
          3: { halign: "right" },
        },
        head: [["Botswana Power Corporation", "", "", ""]],
        body: [
          ["PO Box 48", "", "VAT#", "CO364 230 1112"],
          ["Gaborone", "", "Telephone:", "3603000"],
          [
            `Date: ${date.format("YYYY-MM-DD")}`,
            "",
            "Receipt:",
            receipt.receiptNo,
          ],
        ],
      });
      autoTable(doc, {
        theme: "plain",
        startY: 43,
        headStyles: { fontSize: 14, fontStyle: "bold", halign: "center" },
        styles: { cellPadding: 0.5 },
        head: [["", "", "TAX INVOICE", "", ""]],
        body: [["", "", "", "", ""]],
      });
      doc.line(195.5, 55, 14, 55);
      autoTable(doc, {
        theme: "plain",
        startY: 65,
        tableWidth: 76,
        margin: { left: margin, right: margin },
        headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
        bodyStyles: { fontSize: 10, halign: "center" },
        styles: { cellPadding: 0.5 },
        head: [["Sale  |  Credit Purchase  -  BPC"]],
        body: [[date.format("YYYY-MM-DD HH:mm:ss")]],
      });
      const identity = [];
      const idRow = [];
      if (receipt.clientId) idRow.push(`ID:${receipt.clientId}`);
      if (receipt.receiptNo) idRow.push(`Receipt:${receipt.receiptNo}`);
      if (idRow.length) identity.push(idRow);
      if (receipt.account) identity.push([`Acc:${receipt.account}`]);
      if (receipt.location) identity.push([`Plot:${receipt.location}`]);
      if (receipt.name) identity.push([`Name: ${receipt.name}`]);
      autoTable(doc, {
        theme: "plain",
        startY: Math.max(75, doc.lastAutoTable.finalY + 1),
        tableWidth: 96,
        margin: { left: margin, right: margin, top: 15, bottom: 20 },
        styles: { fontSize: 10, cellPadding: 0.5, overflow: "linebreak" },
        body: identity,
        rowPageBreak: "avoid",
      });
      autoTable(doc, {
        theme: "plain",
        startY: Math.max(100, doc.lastAutoTable.finalY + 2),
        tableWidth: 76,
        margin: { left: margin, right: margin },
        headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
        styles: { cellPadding: 0.5 },
        head: [["TOKEN"]],
      });
      const amounts = [];
      addRow(amounts, "Tendered", money(receipt.amtTendered));
      addRow(amounts, "Cost of Units", money(receipt.costUnits));
      addRow(
        amounts,
        receipt.tariff === "Domestic" ? "Domestic Charge" : "Business Charge",
        money(receipt.standardCharge)
      );
      addRow(amounts, "Government Levy", money(receipt.governmentLevy));
      addRow(amounts, "VAT", money(receipt.vat));
      amounts.push([""]);
      addRow(amounts, "Tariff", receipt.tariff);
      addRow(amounts, "Units", receipt.tokenUnits);
      addRow(amounts, "Meter Type", receipt.meterType);
      addRow(amounts, "krn", receipt.krn);
      addRow(amounts, "ti", receipt.ti);
      addRow(amounts, "STS Meter", receipt.meterNumber);
      addRow(amounts, "sgc", receipt.sgc);
      amounts.forEach((row) => {
        if (row.length === 3) row[1] = ":";
      });
      addTable(amounts, Math.max(109, doc.lastAutoTable.finalY + 2), [
        "Description",
        ":",
        "Amount",
      ]);

      const tokens = keyChangeTokens.slice();
      if (receipt.stsCipher) tokens.push(receipt.stsCipher);
      let tokenY = Math.max(211, doc.lastAutoTable.finalY + 6);
      tokens.forEach((token) => {
        if (tokenY + 13 > doc.internal.pageSize.height - 20) {
          doc.addPage();
          tokenY = 20;
        }
        doc.line(146.5, tokenY, 64.5, tokenY);
        doc.setFontSize(16);
        doc.text(token.replace(/(\d{4})(?=\d)/g, "$1 "), 70.5, tokenY + 9);
        doc.line(146.5, tokenY + 13, 64.5, tokenY + 13);
        tokenY += 13;
      });
      doc.save(
        `ELECTRICITY-${receipt.meterNumber || transaction.transactionDetail}.pdf`
      );
    } else {
      const imgData =
        "data:image/png;base64,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";
      doc.addImage(imgData, "PNG", 14, 15.5, 38.25, 5.4);
      autoTable(doc, {
        theme: "plain",
        startY: 23,
        styles: { fontSize: 10, cellPadding: 0.5 },
        body: [["Telephone: (267) 319 0468"]],
      });
      autoTable(doc, {
        theme: "plain",
        startY: 43,
        headStyles: { fontSize: 14, fontStyle: "bold", halign: "center" },
        styles: { cellPadding: 0.5 },
        head: [["", "", "PAYMENT RECEIPT", "", ""]],
        body: [["", "", "", "", ""]],
      });
      doc.line(195.5, 55, 14, 55);
      autoTable(doc, {
        theme: "plain",
        startY: 65,
        tableWidth: 76,
        margin: { left: margin, right: margin },
        headStyles: { fontSize: 10, fontStyle: "bold", halign: "center" },
        bodyStyles: { fontSize: 10, halign: "center" },
        styles: { cellPadding: 0.5 },
        head: [
          [
            `Sale  |  Credit Purchase  -  ${transaction.provider === "MultiChoice Botswana" ? "MultiChoice" : transaction.provider}`,
          ],
        ],
        body: [[date.format("YYYY-MM-DD HH:mm:ss")]],
      });
      const outlet = [];
      if (transaction.outletId) outlet.push([`Outlet:${transaction.outletId}`]);
      if (outlet.length) {
        autoTable(doc, {
          theme: "plain",
          startY: Math.max(75, doc.lastAutoTable.finalY + 1),
          tableWidth: 96,
          margin: { left: margin, right: margin },
          styles: { fontSize: 10, cellPadding: 0.5 },
          body: outlet,
        });
      }

      const details = [];
      const customer = [];
      const footer = [];
      let pin;
      let rechargeDial;
      const reference =
        response.transaction_reference || transaction.transaction_reference;
      let heading = "Transaction Details";
      switch (transaction.provider) {
        case "MultiChoice Botswana":
          addRow(
            customer,
            "Name",
            [response.customer_name, response.customer_surname]
              .filter(Boolean)
              .join(" ")
          );
          addRow(customer, "Cust No", response.customer_number);
          addRow(details, "Reference", reference);
          addRow(
            details,
            "Amount Paid",
            payment(transaction.transactionAmount)
          );
          addRow(
            details,
            "Smartcard",
            response.smartcard_number || transaction.transactionDetail
          );
          if (response.receiptMessage) footer.push([response.receiptMessage]);
          footer.push(
            ["For queries call DStv Botswana at Tel: 360 5666"],
            ["WhatsApp: 73 038 902"]
          );
          break;
        case "Myzaka cashin":
        case "Myzaka cashout":
          addRow(details, "Phone No", transaction.transactionDetail);
          addRow(details, "Reference", reference || transaction.transactionId);
          addRow(details, "Service", transaction.saleTypeDetail);
          addRow(details, "Amount", payment(transaction.transactionAmount));
          footer.push(["For queries, call Mascom at 124"]);
          break;
        case "Badiphitlho":
          addRow(details, "Service", "Badiphitlho Payment");
          addRow(
            details,
            "Customer ID",
            response.customerId || transaction.transactionDetail
          );
          addRow(details, "Name", response.customerName);
          addRow(details, "Payment Amount", payment(response.baseAmount));
          addRow(details, "Transaction Fee", payment(response.transactionFee));
          addRow(
            details,
            "Total Amount Paid",
            payment(response.transactionAmount)
          );
          addRow(details, "Reference", reference);
          footer.push(["For queries call Badiphitlho at Tel: 316 5277"]);
          break;
        case "Botswana Life":
          addRow(details, "Service", "Botswana Life Payment");
          addRow(
            details,
            "Policy Number",
            (response.customer_info && response.customer_info.account_number) ||
              transaction.transactionDetail
          );
          addRow(
            details,
            "Payment Amount",
            payment(transaction.transactionAmount)
          );
          if (response.customer_info) {
            addRow(
              details,
              "Account Holder",
              response.customer_info.account_holder
            );
            addRow(details, "Description", response.customer_info.description);
          }
          addRow(details, "Receipt", response.receipt);
          footer.push(
            ["For queries contact Contact Center: (+267) 3623700"],
            ["WhatsApp: (+267) 75257556"]
          );
          break;
        case "Gambling":
          addRow(details, "Reference", reference);
          addRow(
            details,
            "Voucher amount",
            payment(transaction.transactionAmount)
          );
          pin = response.voucherPinNumber;
          footer.push([
            "For queries call OTT at +267 76 823 477 or Whatsapp: +267 73 444 101",
          ]);
          break;
        default:
          heading = transaction.provider;
          addRow(details, "Reference", reference);
          addRow(details, "Serial No", response.transaction_reference_str);
          addRow(details, "Amount", payment(transaction.transactionAmount));
          if (transaction.provider.includes("Pinless")) {
            addRow(
              details,
              "Cell No.",
              response.rechargeCellNumber ||
                response.receiverMsisdn ||
                response.msisdn ||
                transaction.transactionDetail
            );
          } else {
            addRow(details, "Voucher", transaction.transactionDetail);
            pin = response.voucherPinNumber;
          }
          addRow(details, "Serial No", response.voucherSerialNumber);
          if (transaction.provider.startsWith("Mascom")) {
            if (pin) rechargeDial = `To recharge: Dial *103*${pin}#`;
            footer.push(["For queries, call Mascom at 124"]);
          } else if (transaction.provider.startsWith("Orange")) {
            if (pin) rechargeDial = `To recharge: Dial *155*${pin}#`;
            footer.push([
              "For support or to activate a line, call Orange at 123",
            ]);
          } else if (transaction.provider.startsWith("beMobile")) {
            if (pin) rechargeDial = `To recharge: Dial *104*${pin}#`;
            footer.push(["For queries, call beMobile at 1333"]);
          }
          break;
      }

      let nextY = Math.max(86, doc.lastAutoTable.finalY + 3);
      if (customer.length) {
        addTable(customer, nextY, ["Customer Details"]);
        nextY = Math.max(114, doc.lastAutoTable.finalY + 6);
      }
      addTable(details, nextY, [heading]);
      if (pin) {
        autoTable(doc, {
          theme: "plain",
          startY: doc.lastAutoTable.finalY + 3,
          margin: { left: margin, right: margin, top: 15, bottom: 20 },
          tableWidth: 82,
          styles: { fontSize: 16, halign: "center", cellPadding: 1 },
          body: [
            [
              transaction.provider === "Gambling"
                ? String(pin).replace(/(.{4})(?=.)/g, "$1 ")
                : String(pin),
            ],
          ],
          rowPageBreak: "avoid",
        });
      }
      if (rechargeDial) {
        autoTable(doc, {
          theme: "plain",
          startY: doc.lastAutoTable.finalY + 3,
          margin: { left: margin, right: margin, top: 15, bottom: 20 },
          tableWidth: 82,
          styles: { fontSize: 10, cellPadding: 0.5 },
          body: [[rechargeDial]],
        });
      }
      autoTable(doc, {
        theme: "plain",
        startY: doc.lastAutoTable.finalY + 6,
        margin: { left: margin, right: margin, top: 15, bottom: 20 },
        tableWidth: 96,
        styles: { fontSize: 10, cellPadding: 0.5, overflow: "linebreak" },
        body: footer,
        rowPageBreak: "avoid",
        willDrawCell: (data) => {
          if (data.row.index === 0)
            doc.line(146.5, data.cell.y - 2, 64.5, data.cell.y - 2);
        },
      });
      doc.save(
        `${transaction.provider}-${date.format("YYYY-MM-DD-HHmmss")}.pdf`
      );
    }
  } catch (error) {
    toastr.error("Oops", "Unable to download this receipt. Please try again.");
  }
};

export const getMerchantstatementForExport =
  (account, reportStartDate, reportEndDate) => async (dispatch) => {
    console.log("reportEndDate ", reportEndDate);
    console.log("reportStartDate ", reportStartDate);
    //convert to epoch first then change to date here
    try {
      dispatch(asyncActionStart());
      //await API call

      //format money
      const formatMoney = (
        amount,
        decimalCount = 2,
        decimal = ".",
        thousands = ","
      ) => {
        try {
          decimalCount = Math.abs(decimalCount);
          decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

          const negativeSign = amount < 0 ? "-" : "";

          let i = parseInt(
            (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
          ).toString();
          let j = i.length > 3 ? i.length % 3 : 0;

          return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
              ? decimal +
                Math.abs(amount - i)
                  .toFixed(decimalCount)
                  .slice(2)
              : "")
          );
        } catch (e) {
          console.log(e);
        }
      };

      //generate file with nested function
      function generatePDF(financialsResponse) {
        function addHeader(doc, title) {
          doc.setFontSize(20);
          const imgData =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAAAkCAYAAABG8ewmAAAAAXNSR0IArs4c6QAADQJJREFUeF7tnU+IX1cVx+8PBf+bKS1UaDUTFFq1NJMqtJBI0kW7iItM0YV104mKhRbNlLboxvypG6WFTBQFRU260LpQki500S6aYAotVJOI2haUJNqChZYkrfUPKD/5vJk7ublzz7nnvvfuzMtMD4Qm/b13/73zPf/uOfeOxuPx2Dnnzrz0qjv78mvu/Ov/dBPvfzf/y0wbP/rB4nfixun/1PN/69TOuve9y0197EPmcUsPHnv2xc5txA0Uje3fZ5z7z1nn/nveubdPlI3lPRvL3ynrwTnGd3afc+ePzv/9vVPOXTXt3DW7+u375QPO/f3QfB8T25xbv2e+LytdONZuDd+2rqwf63gKn3v8yRPu6DMvuJN/+mvzJn+HJq+9qvkDTd9+k9tx26bFf5d0MQL8Ox/8sTv0i+Ml7y15FoGx7Zbrm8Hc9ZnN5rYQNvd987HO/YcdMobScfjFvePu7zYCsAYxpsM/+Ire9Is75xm+CyEwAAuAvPquLi0tffcfJ507des8qGICmBuf6kcAsAasRUjM6+bT+fYZ4x/vmBcaXYg1ZE4ItXdOdmnJ/C5KcN+Bx92RJ35XxIcoPfhrz64d5r5Ge/YfHtNZn4RUgsktWnjv3JFmsjWoZBwAfsOnHixa8DZjZl34SEk6s3deo/ZJMO3HD/enyZ7doIMKgUN/XUnqB+0/uVdvPTfGNmNDEDCvUkvM2JcHvaaEvfWoWabw/N7ZaZMCHk1t3z32ZoVxnObHDj78RTfz2S3q8wCOidckyzgwqW6989s1h9G0jWTm4ySpBtP6jq476NwHZrrNL6WNUy1+4kR3YXNslB7ruq3OTR2V54ErgmVSgwA+64iA65EAPNZvaHECdJSEt6ZTrji4hW95H5c5JBTvU499TXWjR25ypvH5axEDYAISjTZEpl2FgbBwjEOzRGpaIOGUTvxqnzwOieH7WhNMcjRYW/rtJucwqXOEq3F9B9dFA/BKgr9PQbrQFlYvvOcJ0M9+4fbmT0nsDQU688CPXGgV5CxfFfxbb75uyWcuDYYxgNO/ebgV+FP9+4aQkrG003gSAYQAkKg2+AmKovFFk5+BaeCH6WMioFVCuAD4zG0I0AN+C1l9c6mtoYOf+SFIS4KPibnGsTZiZXO7P18E+rhZLIHpL3/HXXjjX81PmuJTwT8+fVD81IAPswOT49FfPq2yhGZ2a5pf6z/skAkTIDlw8El1HJoVooFfNdUtYLA+o4F/q2KgEXwDnJjlrzyq99bW/H9hJt922HPbfmijFvixSDTXhwAhfbOWb57S17GjgJv7yRONqe9p/zfubLR9HwQ2t33uW4vKEQGAAo4tidbgDweJEKAzL23iCbAVceSHX03Oqw/w+4YRAETrJUKyHnrkS8mfL2vwhzOCcU9uc+5/F9LLcOUO5264aGaamA3hQjwiFeF/x/r5bcmY0Ir4/m2oFvgtwUI/Xsbw51ldCLR0b2I+tcSk2iwjmPSWeioG0Av4GRgWAGaMRJIW7xP89I3fI1kiuBFHf/711Q1+ZvfSnHN/uU/mF82KSL0lBfrYD8e3Z1stRW0Df0MAP/NB2CFINSsAN6pgGzDeVappVdLX1PbdTf4OFPfVG/jp6IqN94oMd+7U95K+TN/gz0XtJSG0ajS/Z9qnr5DBv/lc2ZaVFOhj//sjc849M5nW/i01YzWzv0Tz+9VDADA/yZIqnGPIZ5pFHH+8mD+tLjFW+aZP72mai83/3sBP45NbHliUMvHgJX+7b/DnhNCaAD+LLwGS30qi/vjBmPyaZsc8JhsvprZ+8VA0v5+PtsXJHBGmBoq1Pn64z9TLvd4W/LQbWsOh69sr+JEwUs7AcoFf0/xso5z//feT67yqND8z1HIGSsAvARtf/5aFDDptJ6BN4G9o4Gc9j0/I2t/o3oRBPi3+lGLQLuBH6KCYfUzOK8Bewa9p8eUy+zUQa2bWqgO/tnNQYvbjPqQCfR/e79y1sxf59LmptG/cJvA3RPBrux3xWghqPFSOJVqf5rqAn/dnH/rZ4m6YzzLtDfxDCPhhdZClJ+Xma9spqwr8uUw8a8BPaycOdGlBxhJLA04dIvi1+Rl2UEJ3lJyPk79+KGfpX/J7V/CHOwze6ugF/DnQ1d7qI7uJPX7MKokw+c8cf0RMoNDAT4KQlqWY+4rsMpjeb7vPHw5AK7zhOQOjLjZHmixAjInKwU9GmX5YB1KQsTAoNkjwdxFI0W7Yrp23Nck8JdQV/PQ1ceM9jelP4A9LvBP4kWYedFolnKZxNVfBAhhf5phbSLWgJmFW5dor/d30wbuAH/ARdENDpcx0P2CjidpUxEmBPsmP/8O0c68JRVolrkYXoGnvton2+3XrMqaIv3Ip7337/L69cN8fv18FvwY+tK2lIGf9NVc2Glei5cjtt2RP1U7vZf7Z7RkN/FpOPkC1lK+GQbqc9JICfbwnAVlzE6xCZ6hmP+OSvo8h4h/ylwR+/HIpZT3Gm4ZN+D1VxxKCn5hD9cKenMatCX4ED+aVmk+/AILBgz8HVsvvlKRaK9KkQF/ObZCi4iV1BV20bC3Nr4Gf3zJxlBh4qS2+8BnL55Se0YSLT4Hnmargt6Qt1gA/oCdPmnJia2VUbfCbEjpqVvWVbLm9ekTO2su1o0XFrYG/IYJfi2m8Bf6LcgjwkUNv8dn7BD+BNTS95RCRWGpq4Gc+1mSMuF2ED5ZH7lyD5r0a4MfUJwW3pJRX8t1J592SOMEnnLQGXGvgb4jgz50TkNH8VrNfypPxx+z5pdYqXiUMVDX7GRBMbmL0hVlo4A9LcJk8C8OWhc9VTpk9AA2Lw6rxfRuD3+ortQMpAaaCrfQADy3QZwWvll1oCfxdbuA3xFIs4Nc+cR/R/qKAn+U8MECGprVo+dTk2qT3xuWQcbuWU0xKNH/N4otLxqFpfiLVOSLwRFJNiZaP29SOEiNeYKlhx22QDv2wBP6GCH4tmJk7YGQgW30eaz7TtdNWX44XLb+3AT/t5pKKSgXA4DW/NTHHsujaMzWPEqNfS+BviODXYhm+wElZVyxXjqyD4E1OdCqhrpq/WpJPySTiZ9uCn3ZyQTrcD1wAC70FfuecFuizLKL1mdyuwxDBrwlFizUD6LfvXtzKW+703rC4p/f0Xut37xP8tJXbHrHs8ecEySDM/uXQ/FqSTtsPnHovt104NPDngn3Gmv6VKuzB6qCuwCfiVSnsacMfXTQ//TExJKp0ihAxCUysXLR+zWt+LdDX5sPm3tEAMzTwS2nOzNEQ7PNLEVfXlWj/Lmb/spT05r536veu4M9p7cY6yBzemWtjTWh+LdAHgxecVrP4nf3NQ6kPr6XaDgn8uSIpo8nvlyAEsekSl4UX24I/PMwjrm+5bAN+MT9pB4nwbC7haM1rfs2nNZq1SzCuAUcL/A0F/Dlzn7wHzjQouMgj1v41FQt9Ye77NPxqx3i10fq804fmp53c8V25I8TXNPg1Jk9V8JV8bO0QDCnwt9Lg90VSWEMaFWp939RyHOAJ8Clv90lDlBFzfmWY/7JqND8Ly3nlXG4okab9a5b0+vFQR63GHrpU9ZUAMn5W28bKpfPm+tXalgJ/tcBP/oOlQCpVxhzP07C3ry1NnKtCVh6Vn30Qmp5TrD3wpXL2VQX+XPBP0/65bcM+PkrW/VgJ8Ody1i0Zedri5C77SLVfC/x9fURiIJxnUGDup7qOT5pma5rdqdLs1LBtLODwslmAj8ZPpbyvKvCzCDkQS1WGuazBvvjGH6SQbG8lwK/t7VvTeXOLIx3xxXupYh9NYOQ0bs5Pz4019zvA594DS6Zjrq0Ev8IfFKVhBZQIAbQ8l4CE51tQk8J9GVKty2j95vvHqVz5NkcNGea65BF/ukj8Q5f+w2SKuF0pwBJGRdvMo+Qdsa5fAklXv1sbXJ/Hb0n9tKnzb3tRZ80tSwQPwO+o8eNlIluVWv5wu9oXhLFTRUWodFEnl3LwflwQlPLx435Hu/b9dJy65qpmFDIchHTJhunkG4HZNCBrST+5hKESgEvPaheHOGm7rcsJNLlBS1o2p2Fz7ca/S4E/6eRbLstI3UVoiUFI75aO2T+P8OV+gi41E5m+cVmxWrWr73wdjXZ6FdqeOyEtxXWjcxfeHIf3ejWWWCIy2Hbdcu8xafoPrQ8mwAGHJWZPSprGNwjl5kWEFPMfSapVDubmlPrdX7msXsSYuiEGxuNK6p61zSVjjLU/W1houD6ZPeVeaNHy1LVjVoHEOiJI6TN1lZj2AZk7Jj3rzfwpZmqT49CGSRaS1hAC7AhIiWuppuFt8gbE698TL43G4/EYpqczgEhQjEa6AK903vQP4Jo90B77Zz60C9GuRRqWjr3352FcmBbzFaaD+WoC308AsNEvZK3eK508c8IFgHKRd55hLXie/7IWpeXJpeMb2PNg0uOSofl798LzJcAqf3IZrKmp/R9LYqgtO+u6+AAAAABJRU5ErkJggg==";
          doc.addImage(imgData, "PNG", 14, 22, 55, 10);

          doc.setFontSize(28);
          doc.text(title, 70, 32);
          doc.setTextColor("#000000");
        }
        const doc = new jsPDF();
        const pageHeight = 297;
        const marginTop = 30;
        const marginBottom = 20;

        function addTable(items, title, columns) {
          addHeader(doc, title);
          // console.log("merchant######", financialsResponse.merchant);

          doc.setFontSize(12);
          doc.text("Cachet Enterprises (T/A PrepaidPlus)", 120, 43);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.text("P.O. Box 402517, Gaborone", 120, 51);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.text("Tel: 3190468", 120, 59);
          doc.setTextColor("#000000");

          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Merchant Summary Statement`, 14, 71);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(
            `Vending client : ${financialsResponse.merchant.name}`,
            14,
            85
          );
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(`${financialsResponse.merchant.suburb}`, 14, 93);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(
            `Merchant account : ${financialsResponse.merchant.account}`,
            14,
            101
          );
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.text(
            `Date from : ${reportStartDate.format(
              "YYYY-MM-DD HH:mm:ss"
            )} to : ${reportEndDate.format("YYYY-MM-DD HH:mm:ss")}`,
            14,
            111
          );
          doc.setTextColor("#000000");

          const rows = items.map((item) => Object.values(item));

          doc.autoTable({
            startY: marginTop + 111 + 15,
            head: [columns],
            body: rows,
            theme: "plain",
            margin: { top: marginTop },
            didDrawPage: (data) => {
              addHeader(doc, title);
            },
          });

          if (doc.lastAutoTable.finalY > pageHeight - marginBottom) {
            doc.addPage();
          }
        }

        function addDepositsTable(doc, items, title, columns) {
          function createAutoTableOptions(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239],
                textColor: [0, 0, 0],
                fontStyle: "bold",
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  doc.setDrawColor(0, 0, 0); // Black color
                  doc.setLineWidth(0.5); // Line width
                  doc.line(
                    data.cell.x,
                    data.cell.y + data.cell.height,
                    data.cell.x + data.cell.width,
                    data.cell.y + data.cell.height
                  ); // Draw line
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          function createAutoTableOptionsUnBold(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            return {
              startY: startY,
              head: [tableColumns], // Always include the table columns as the header
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                // No bold font style
              },
              columnStyles: {
                // Align the contents and header of the last column to the right
                [tableColumns.length - 1]: { halign: "right" },
              },
              didDrawCell: (data) => { },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  // No need to set font to bold here
                }
              },
              didParseCell: (data) => {
                if (data.column.index === tableColumns.length - 1) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          const marginTop = 30;
          const marginBottom = 20;
          const pageHeight = 297;

          addHeader(doc, title);

          let rows = [];
          items.forEach((item) =>
            rows.push([
              item.account,
              item.merchantName,
              format(new Date(item.transactionDateTime), "DD-MM-YYYY"),
              item.bank,
              format(new Date(item.dateOfDeposit), "DD-MM-YYYY"),
              formatMoney(item.transactionAmount),
            ])
          );
          let sum = 0;
          items.forEach((item) => (sum += item.transactionAmount));
          // rows.push(["Total Deposits", "", "", "", "", formatMoney(sum)]);

          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Merchant deposits`, 14, 45);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.setFont("helvetica", "normal");
          doc.text("Date from: ", 14, 55);

          doc.setFont("helvetica", "bold");
          doc.text(
            `${format(reportStartDate, "DD-MM-YYYY HH:mm:ss")} to ${format(
              reportEndDate,
              "DD-MM-YYYY HH:mm:ss"
            )}`,
            34,
            55
          );

          doc.setFont("helvetica", "normal");
          // doc.text(`Date from : ${reportStartDate} to : ${reportEndDate}`, 14, 55);
          doc.setTextColor("#000000");

          let startY = marginTop + 35;

          let autoTableOptions = createAutoTableOptions(startY, rows, columns);
          doc.autoTable(autoTableOptions);

          let finalY = doc.lastAutoTable.finalY;

          startY = finalY;

          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            ["Total Deposits", "", "", "", "", formatMoney(sum)],
            true
          );

          doc.autoTable(autoTableOptions);

          while (finalY > pageHeight - marginBottom) {
            doc.addPage();
            startY = marginTop + 35;
            autoTableOptions = createAutoTableOptions(startY, rows, columns);
            doc.autoTable(autoTableOptions);
            finalY = doc.lastAutoTable.finalY;
          }
        }

        function addCommissionsEarnedTable(doc, items, title, columns) {
          const marginTop = 30;
          const marginBottom = 20;
          const pageHeight = 297;

          addHeader(doc, title);

          console.log("title", title);

          let rows = [];
          console.log("commission items", items);
          items.map((item) =>
            rows.push([
              `${item.saleType}-${item.provider}`,
              formatMoney(item.transactionAmount),
              item.commissionRate,
              formatMoney(item.commissionAmount),
            ])
          );

          let transactionAmountSum = 0;

          items.map((item) => (transactionAmountSum += item.transactionAmount));

          let commissionAmountSum = 0;

          items.map((item) => (commissionAmountSum += item.commissionAmount));

          // rows.push([
          //   "Total Commission",
          //   formatMoney(transactionAmountSum),
          //   "",
          //   formatMoney(commissionAmountSum),
          // ]);

          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Merchant Commission Earned`, 14, 45);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.setFont("helvetica", "normal");
          doc.text("Date from: ", 14, 55);

          doc.setFont("helvetica", "bold");
          doc.text(
            `${format(reportStartDate, "DD-MM-YYYY HH:mm:ss")} to ${format(
              reportEndDate,
              "DD-MM-YYYY HH:mm:ss"
            )}`,
            34,
            55
          );

          doc.setFont("helvetica", "normal");
          // doc.text(`Date from : ${reportStartDate} to : ${reportEndDate}`, 14, 55);
          doc.setTextColor("#000000");

          let startY = marginTop + 35;

          function createAutoTableOptions(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239],
                textColor: [0, 0, 0],
                fontStyle: "bold",
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  doc.setDrawColor(0, 0, 0); // Black color
                  doc.setLineWidth(0.5); // Line width
                  doc.line(
                    data.cell.x,
                    data.cell.y + data.cell.height,
                    data.cell.x + data.cell.width,
                    data.cell.y + data.cell.height
                  ); // Draw line
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          function createAutoTableOptionsUnBold(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            // Define fixed column widths to align columns with the previous table
            const columnWidths = tableColumns.map((_, index) => {
              // You can customize the widths as per your requirement
              if (index === tableColumns.length - 1) {
                return "auto"; // Let the last column width adjust based on its content
              }
              return "auto"; // or specify a fixed width like '20%', '30px', etc.
            });

            return {
              startY: startY,
              head: [tableColumns], // Always include the table columns as the header
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                // No bold font style
              },
              columnStyles: tableColumns.reduce((styles, _, index) => {
                styles[index] = { cellWidth: columnWidths[index] };
                if (index === tableColumns.length - 1) {
                  styles[index].halign = "right"; // Align the contents and header of the last column to the right
                }
                return styles;
              }, {}),
              didDrawCell: (data) => {},
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  // No need to set font to bold here
                }
              },
              didParseCell: (data) => {
                if (data.column.index === tableColumns.length - 1) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }
          let autoTableOptions = createAutoTableOptions(startY, rows, columns);
          doc.autoTable(autoTableOptions);
          let finalY = doc.lastAutoTable.finalY;
          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            [
              "Total Commission",
              "   ",
              "   ",
              formatMoney(transactionAmountSum),
              "   ",
              "   ",
              "   ",
              "   ",
              formatMoney(commissionAmountSum),
            ],
            true
          );
          doc.autoTable(autoTableOptions);

          finalY = doc.lastAutoTable.finalY;
          while (finalY > pageHeight - marginBottom) {
            doc.addPage();
            startY = marginTop + 35;
            autoTableOptions = createAutoTableOptions(startY, rows, columns);
            doc.autoTable(autoTableOptions);
            finalY = doc.lastAutoTable.finalY;
          }
        }

        function addReversalsTable(doc, items, title, columns) {
          const marginTop = 30;
          const marginBottom = 20;
          const pageHeight = 297;

          addHeader(doc, title);

          console.log("title", title);

          let rows = [];
          console.log("reversals items", items);
          items.map((item) =>
            rows.push([
              account,
              format(new Date(item.transactionDateTime), "DD-MM-YYYY"),
              item.reversalType,
              item.reversalReason,
              formatMoney(item.transactionAmount),
            ])
          );

          let transactionAmountSum = 0;

          items.map((item) => (transactionAmountSum += item.transactionAmount));

          // rows.push([
          //   "Total Commission",
          //   formatMoney(transactionAmountSum),
          //   "",
          //   formatMoney(commissionAmountSum),
          // ]);

          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Merchant Reversals`, 14, 45);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.setFont("helvetica", "normal");
          doc.text("Date from: ", 14, 55);

          doc.setFont("helvetica", "bold");
          doc.text(
            `${format(reportStartDate, "DD-MM-YYYY HH:mm:ss")} to ${format(
              reportEndDate,
              "DD-MM-YYYY HH:mm:ss"
            )}`,
            34,
            55
          );

          doc.setFont("helvetica", "normal");
          // doc.text(`Date from : ${reportStartDate} to : ${reportEndDate}`, 14, 55);
          doc.setTextColor("#000000");

          let startY = marginTop + 35;

          function createAutoTableOptions(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239],
                textColor: [0, 0, 0],
                fontStyle: "bold",
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  doc.setDrawColor(0, 0, 0); // Black color
                  doc.setLineWidth(0.5); // Line width
                  doc.line(
                    data.cell.x,
                    data.cell.y + data.cell.height,
                    data.cell.x + data.cell.width,
                    data.cell.y + data.cell.height
                  ); // Draw line
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          function createAutoTableOptionsUnBold(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            // Define fixed column widths to align columns with the previous table
            const columnWidths = tableColumns.map((_, index) => {
              // You can customize the widths as per your requirement
              if (index === tableColumns.length - 1) {
                return "auto"; // Let the last column width adjust based on its content
              }
              return "auto"; // or specify a fixed width like '20%', '30px', etc.
            });

            return {
              startY: startY,
              head: [tableColumns], // Always include the table columns as the header
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                // No bold font style
              },
              columnStyles: tableColumns.reduce((styles, _, index) => {
                styles[index] = { cellWidth: columnWidths[index] };
                if (index === tableColumns.length - 1) {
                  styles[index].halign = "right"; // Align the contents and header of the last column to the right
                }
                return styles;
              }, {}),
              didDrawCell: (data) => {},
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  // No need to set font to bold here
                }
              },
              didParseCell: (data) => {
                if (data.column.index === tableColumns.length - 1) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }
          let autoTableOptions = createAutoTableOptions(startY, rows, columns);
          doc.autoTable(autoTableOptions);
          let finalY = doc.lastAutoTable.finalY;
          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            [
              "Total Reversal",
              "   ",
              "   ",
              "   ",
              formatMoney(transactionAmountSum),
            ],
            true
          );
          doc.autoTable(autoTableOptions);

          finalY = doc.lastAutoTable.finalY;
          while (finalY > pageHeight - marginBottom) {
            doc.addPage();
            startY = marginTop + 35;
            autoTableOptions = createAutoTableOptions(startY, rows, columns);
            doc.autoTable(autoTableOptions);
            finalY = doc.lastAutoTable.finalY;
          }
        }
        function addOutletSalesSummaryTable(doc, items, title, columns) {
          const marginTop = 30;
          const marginBottom = 20;
          const pageHeight = 297;

          addHeader(doc, title);
          let rows = [];

          items.map((item) =>
            rows.push([
              item.outletId,
              item.outletName,
              formatMoney(item.transactionAmount),
            ])
          );
          let outletSales = 0;

          items.map(
            (item) => (outletSales += parseFloat(item.transactionAmount))
          );
          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Outlet Sales`, 14, 45);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.setFont("helvetica", "normal");
          doc.text("Date from: ", 14, 55);

          doc.setFont("helvetica", "bold");
          doc.text(
            `${format(reportStartDate, "DD-MM-YYYY HH:mm:ss")} to ${format(
              reportEndDate,
              "DD-MM-YYYY HH:mm:ss"
            )}`,
            34,
            55
          );

          doc.setFont("helvetica", "normal");
          // doc.text(`Date from : ${reportStartDate} to : ${reportEndDate}`, 14, 55);
          doc.setTextColor("#000000");

          let startY = marginTop + 35;

          function createAutoTableOptions(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239],
                textColor: [0, 0, 0],
                fontStyle: "bold",
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  doc.setDrawColor(0, 0, 0); // Black color
                  doc.setLineWidth(0.5); // Line width
                  doc.line(
                    data.cell.x,
                    data.cell.y + data.cell.height,
                    data.cell.x + data.cell.width,
                    data.cell.y + data.cell.height
                  );
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }
          function createAutoTableOptionsUnBold(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            return {
              startY: startY,
              head: [tableColumns], // Always include the table columns as the header
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                // No bold font style
              },
              columnStyles: {
                // Align the contents and header of the last column to the right
                [tableColumns.length - 1]: { halign: "right" },
              },
              didDrawCell: (data) => {},
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  // No need to set font to bold here
                }
              },
              didParseCell: (data) => {
                if (data.column.index === tableColumns.length - 1) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }
          let autoTableOptions = createAutoTableOptions(startY, rows, columns);
          doc.autoTable(autoTableOptions);

          let finalY = doc.lastAutoTable.finalY;

          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            ["Totals Sales", formatMoney(outletSales)],
            true
          );

          doc.autoTable(autoTableOptions);

          finalY = doc.lastAutoTable.finalY;
          while (finalY > pageHeight - marginBottom) {
            doc.addPage();
            startY = marginTop + 35;
            autoTableOptions = createAutoTableOptions(startY, rows, columns);
            doc.autoTable(autoTableOptions);
            finalY = doc.lastAutoTable.finalY;
          }
        }

        function addMerchantSummaryStatementTable(doc, items, title, columns) {
          function createAutoTableOptions(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239],
                textColor: [0, 0, 0],
                fontStyle: "bold",
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  doc.setDrawColor(0, 0, 0); // Black color
                  doc.setLineWidth(0.5); // Line width
                  doc.line(
                    data.cell.x,
                    data.cell.y + data.cell.height,
                    data.cell.x + data.cell.width,
                    data.cell.y + data.cell.height
                  ); // Draw line
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }
          function createAutoTableOptionsLines(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            // Filter out header row if all cells are empty strings
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                fontStyle: "bold", // Bold font style for the header
              },
              didDrawCell: (data) => {
                if (data.section === "head" && data.row.index === 0) {
                  // Calculate the total width of the table
                  let tableWidth = data.table.columns.reduce(
                    (acc, col) => acc + col.width,
                    0
                  );

                  // Draw a line above the table header
                  if (data.column.index === 0) {
                    doc.setDrawColor(0, 0, 0); // Black color
                    doc.setLineWidth(0.5); // Line width
                    doc.line(
                      data.cell.x,
                      data.cell.y,
                      data.cell.x + data.cell.width,
                      data.cell.y
                    ); // Draw line
                  }

                  // Draw a line below the table header
                  if (data.column.index === 0) {
                    doc.setDrawColor(0, 0, 0); // Black color
                    doc.setLineWidth(0.5); // Line width
                    doc.line(
                      data.cell.x,
                      data.cell.y + data.cell.height,
                      data.cell.x + data.cell.width,
                      data.cell.y + data.cell.height
                    ); // Draw line
                  }
                }

                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  doc.setFont(undefined, "bold");
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          function createAutoTableOptionsUnBold(
            startY,
            rows,
            tableColumns,
            isDepositsTable
          ) {
            // Filter out header row if all cells are empty strings
            const hasNonEmptyHeaders = tableColumns.some(
              (column) => column !== ""
            );

            return {
              startY: startY,
              head: hasNonEmptyHeaders ? [tableColumns] : [],
              body: rows,
              theme: "plain",
              margin: { top: marginTop },
              headStyles: {
                fillColor: [235, 239, 239], // Grey background color for the header
                textColor: [0, 0, 0], // Black text color for the header
                // No bold font style
              },
              didDrawCell: (data) => {},
              willDrawCell: (data) => {
                if (
                  data.section === "body" &&
                  data.row.index < rows.length &&
                  (rows[data.row.index][0]
                    .toLowerCase()
                    .includes("starting balance") ||
                    rows[data.row.index][0].toLowerCase().includes("sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("total sales") ||
                    rows[data.row.index][0]
                      .toLowerCase()
                      .includes("closing balance"))
                ) {
                  // No need to set font to bold here
                }
              },
              didParseCell: (data) => {
                if (
                  (data.section === "head" || data.section === "body") &&
                  data.column.index === tableColumns.length - 1
                ) {
                  data.cell.styles.halign = "right"; // Align the contents of the last column and headers to the right
                }
              },
            };
          }

          const marginTop = 30;
          const pageHeight = 297;

          addHeader(doc, title);
          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text("Cachet Enterprises (T/A PrepaidPlus)", 120, 43);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");
          doc.text("P.O. Box 402517, Gaborone", 120, 51);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.text("Tel: 3190468", 120, 59);
          doc.setTextColor("#000000");

          doc.setFontSize(14);
          doc.setFont(undefined, "bold");
          doc.text(`Merchant Summary Statement`, 14, 71);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(
            `Vending client : ${financialsResponse.merchant.name}`,
            14,
            85
          );
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(`${financialsResponse.merchant.suburb}`, 14, 93);
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");
          doc.text(
            `Merchant account : ${financialsResponse.merchant.account}`,
            14,
            101
          );
          doc.setTextColor("#000000");

          doc.setFontSize(12);
          doc.setFont(undefined, "normal");

          doc.setFont("helvetica", "normal");
          doc.text("Date from: ", 14, 111);

          doc.setFont("helvetica", "bold");
          doc.text(
            `${format(reportStartDate, "DD-MM-YYYY HH:mm:ss")} to ${format(
              reportEndDate,
              "DD-MM-YYYY HH:mm:ss"
            )}`,
            34,
            111
          );

          doc.setFont("helvetica", "normal");

          // doc.text(`Date from : ${reportStartDate} to : ${reportEndDate}`, 14, 111);
          // doc.setTextColor("#000000");

          let preDepositRows = [];

          preDepositRows.push([
            "Starting Balance",
            formatMoney(financialsResponse.startingBalance),
          ]);

          let startY = marginTop + 95;

          let autoTableOptions = createAutoTableOptions(
            startY,
            preDepositRows,
            columns,
            false
          );
          doc.autoTable(autoTableOptions);

          let finalY = doc.lastAutoTable.finalY;

          startY = finalY;

          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            ["Deposits", formatMoney(financialsResponse.depositsTotal)],
            true
          );

          doc.autoTable(autoTableOptions);
          finalY = doc.lastAutoTable.finalY;
          let postDepositRows = [];

          postDepositRows.push([
            "Commission Credited",
            formatMoney(financialsResponse.creditedCommissionListTotal),
          ]);
          postDepositRows.push([
            "Reversals",
            formatMoney(financialsResponse.reversalsTotal),
          ]);
          postDepositRows.push(["Sales", ""]);

          items.forEach((item) =>
            postDepositRows.push([
              `${item.saleType} - ${item.provider}`,
              formatMoney(item.transactionAmount),
            ])
          );
          finalY = doc.lastAutoTable.finalY;

          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            postDepositRows,
            ["", ""],
            true
          );
          doc.autoTable(autoTableOptions);

          finalY = doc.lastAutoTable.finalY;
          let postTotalSales = [];
          postTotalSales.push([
            "Withdrawals",
            formatMoney(financialsResponse.withdrawalsTotal),
          ]);
          postTotalSales.push([
            "Closing Balance",
            formatMoney(financialsResponse.closingBalance),
          ]);
          postTotalSales.push(["Commissions", ""]);

          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            postTotalSales,
            ["Total Sales", formatMoney(financialsResponse.salesTotal)],
            true
          );
          doc.autoTable(autoTableOptions);
          finalY = doc.lastAutoTable.finalY;
          autoTableOptions = createAutoTableOptionsUnBold(
            finalY,
            [],
            [
              "Commission Earned by Merchants",
              formatMoney(financialsResponse.earnedCommissionTotal),
            ],
            true
          );
          doc.autoTable(autoTableOptions);
          finalY = doc.lastAutoTable.finalY;
          const lastFinalY = doc.lastAutoTable.finalY;

          while (lastFinalY > pageHeight - marginBottom) {
            doc.addPage();
            startY = marginTop + 35;
            autoTableOptions = createAutoTableOptions(
              startY,
              postDepositRows,
              columns,
              true
            );
            doc.autoTable(autoTableOptions);
            finalY = doc.lastAutoTable.finalY;
          }
        }
        addMerchantSummaryStatementTable(
          doc,
          financialsResponse.totalsByProvider,
          "MERCHANT STATEMENT",
          ["Item", "Amount(BWP)"]
        );
        doc.addPage();

        addDepositsTable(
          doc,
          financialsResponse.depositsList,
          "MERCHANT STATEMENT",
          [
            "Account",
            "Merchant",
            "Transaction Date",
            "Bank",
            "Deposit Date",
            "Amount",
          ]
        );

        doc.addPage();
        addOutletSalesSummaryTable(
          doc,
          financialsResponse.outletSummary,
          "MERCHANT STATEMENT",
          ["Outlet Id", "Outlet Name", "Sales"]
        );

        doc.addPage();

        addCommissionsEarnedTable(
          doc,
          financialsResponse.totalsByProvider,
          "MERCHANT STATEMENT",
          ["Product Type", "Sales", "Commission Rate", "Commission Amount"]
        );
        if (financialsResponse.reversalsList.length > 1) {
          doc.addPage();
          addReversalsTable(
            doc,
            financialsResponse.reversalsList,
            "MERCHANT STATEMENT",
            [
              "Account",
              "Transaction Date",
              "Transaction Type",
              "Reversal reason",
              "Amount",
            ]
          );
        }

        return doc;
      }

      const response = await axios.post("reports-merchantStatement", {
        reportStartDate: reportStartDate,
        reportEndDate: reportEndDate,
        account: account,
      });

      if (response.status != 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        const doc = generatePDF(response.data);
        const buffer = Buffer.from(doc.output("arraybuffer"));
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        saveAs(blob, `Merchant Statement-${account}.pdf`);
      }
      dispatch(closeModal());

      dispatch(asyncActionFinish());
    } catch (error) {
      if (error) {
        console.log(error);
      }
      toastr.error("Oops", "Something went wrong");
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };

const getUsersName = (userId, users) => {
  let user = users.find((u) => {
    return u.userId.toString() === userId.toString();
  });

  return user ? (user.name ? user.name : "Not Set") : "Not Set";
};

export const reportByCategory = (values) => async (dispatch, getState) => {
  const outletId =
    typeof values.outletId === "string"
      ? values.outletId
      : values.outletId.value;
  // const reportStartDate = moment(values.reportStartDate)
  //   .startOf("day")
  //   .toDate(); // set to 12:00 am today
  // const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const reportStartDate = values.reportStartDate; // set to 12:00 am today
  const reportEndDate = values.reportEndDate; // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");

  try {
    dispatch(asyncActionStart());

    let query = transactionsRef
      .where("transactionDateTime", ">=", reportStartDate)
      .where("transactionDateTime", "<=", reportEndDate)
      .where("outletId", "==", outletId)
      .where("transactionType", "==", "Sale")
      .where("transactionStatus", "==", "Successful")
      .orderBy("transactionDateTime");

    let transactions = await query.get().then(function (querySnapshot) {
      const result = querySnapshot.docs
        .filter((doc) => isVisibleRecord(doc.data()))
        .map((doc) => {
          return {
            saleType: doc.data().saleType,
            transactionAmount: doc.data().transactionAmount,
          };
        })
        .reduce(
          function (arr, doc) {
            if (!(doc.saleType in arr))
              arr.__array.push((arr[doc.saleType] = doc));
            else {
              arr[doc.saleType].transactionAmount += parseFloat(
                doc.transactionAmount
              )
                ? parseFloat(doc.transactionAmount)
                : 0;
            }
            return arr;
          },
          {
            __array: [],
          }
        );

      return result.__array;
    });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const reportByDate = (values) => async (dispatch, getState) => {
  const outletId =
    typeof values.outletId === "string"
      ? values.outletId
      : values.outletId.value;
  // const reportStartDate = moment(values.reportStartDate)
  //   .startOf("day")
  //   .toDate(); // set to 12:00 am today
  // const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const reportStartDate = values.reportStartDate; // set to 12:00 am today
  const reportEndDate = values.reportEndDate; // set to 23:59 pm today

  console.log("reportStartDate", reportStartDate);
  console.log("reportEndDate", reportEndDate);

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");

  try {
    dispatch(asyncActionStart());

    let query = transactionsRef
      .where("transactionDateTime", ">=", reportStartDate)
      .where("transactionDateTime", "<=", reportEndDate)
      .where("outletId", "==", outletId)
      .where("transactionType", "==", "Sale")
      .where("transactionStatus", "==", "Successful")
      .orderBy("transactionDateTime");

    let transactions = await query.get().then(function (querySnapshot) {
      const result = querySnapshot.docs
        .filter((doc) => isVisibleRecord(doc.data()))
        .map((doc) => {
          return {
            transactionDateTime: moment(
              doc.data().transactionDateTime.toDate()
            ).format("YYYY-MM-DD"),
            transactionAmount: doc.data().transactionAmount,
          };
        })
        .reduce(
          function (arr, doc) {
            if (!(doc.transactionDateTime in arr))
              arr.__array.push((arr[doc.transactionDateTime] = doc));
            else {
              arr[doc.transactionDateTime].transactionAmount += parseFloat(
                doc.transactionAmount
              )
                ? parseFloat(doc.transactionAmount)
                : 0;
            }
            return arr;
          },
          {
            __array: [],
          }
        );

      return result.__array;
    });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const reportByUser = (values) => async (dispatch, getState) => {
  const outletId =
    typeof values.outletId === "string"
      ? values.outletId
      : values.outletId.value;
  // const reportStartDate = moment(values.reportStartDate)
  //   .startOf("day")
  //   .toDate(); // set to 12:00 am today
  // const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const reportStartDate = values.reportStartDate; // set to 12:00 am today
  const reportEndDate = values.reportEndDate; // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");
  const outletUsersRef = firestore.collection("outlet_users");

  try {
    dispatch(asyncActionStart());

    let query = transactionsRef
      .where("transactionDateTime", ">=", reportStartDate)
      .where("transactionDateTime", "<=", reportEndDate)
      .where("outletId", "==", outletId)
      .where("transactionType", "==", "Sale")
      .where("transactionStatus", "==", "Successful")
      .orderBy("transactionDateTime");

    let usersQuery = outletUsersRef.where("outletId", "==", outletId);

    let usersQuerySnap = await usersQuery.get();

    let users = [];

    for (let i = 0; i < usersQuerySnap.docs.length; i++) {
      let user = {
        ...usersQuerySnap.docs[i].data(),
        id: usersQuerySnap.docs[i].id,
      };
      users.push(user);
    }

    let transactions = await query.get().then(function (querySnapshot) {
      const result = querySnapshot.docs
        .filter((doc) => isVisibleRecord(doc.data()))
        .map((doc) => {
          return {
            userId: doc.data().createdBy,
            name: getUsersName(doc.data().createdBy, users),
            transactionAmount: doc.data().transactionAmount,
          };
        })
        .reduce(
          function (arr, doc) {
            if (!(doc.userId in arr)) arr.__array.push((arr[doc.userId] = doc));
            else {
              arr[doc.userId].transactionAmount += parseFloat(
                doc.transactionAmount
              )
                ? parseFloat(doc.transactionAmount)
                : 0;
            }
            return arr;
          },
          {
            __array: [],
          }
        );

      return result.__array;
    });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const reportByOutlet = (values) => async (dispatch, getState) => {
  const account = values.account;
  // const reportStartDate = moment(values.reportStartDate)
  //   .startOf("day")
  //   .toDate(); // set to 12:00 am today
  // const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const reportStartDate = values.reportStartDate; // set to 12:00 am today
  const reportEndDate = values.reportEndDate; // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");

  try {
    dispatch(asyncActionStart());

    let query = transactionsRef
      .where("transactionDateTime", ">=", reportStartDate)
      .where("transactionDateTime", "<=", reportEndDate)
      .where("account", "==", account)
      .where("transactionType", "==", "Sale")
      .where("transactionStatus", "==", "Successful")
      .orderBy("transactionDateTime");

    let transactions = await query.get().then(function (querySnapshot) {
      const result = querySnapshot.docs
        .filter((doc) => isVisibleRecord(doc.data()))
        .map((doc) => {
          return {
            outletId: doc.data().outletId,
            outletName: doc.data().outletName ? doc.data().outletName : "N/A",
            transactionAmount: doc.data().transactionAmount,
          };
        })
        .reduce(
          function (arr, doc) {
            if (!(doc.outletId in arr))
              arr.__array.push((arr[doc.outletId] = doc));
            else {
              arr[doc.outletId].transactionAmount += parseFloat(
                doc.transactionAmount
              )
                ? parseFloat(doc.transactionAmount)
                : 0;
            }
            return arr;
          },
          {
            __array: [],
          }
        );

      return result.__array;
    });

    let sortedTransactions = transactions.sort((a, b) => {
      if (a.outletId < b.outletId) {
        return -1;
      }
      if (a.outletId > b.outletId) {
        return 1;
      }

      return 0;
    });

    dispatch({ type: FETCH_REPORTS, payload: sortedTransactions });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const getGroupTransactionsForDashboard =
  (values) => async (dispatch, getState) => {
    const account = values.account;
    const reportStartDate = moment(values.reportStartDate)
      .startOf("day")
      .toDate(); // set to 12:00 am today
    const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

    const firestore = firebase.firestore();

    const accountRef = firestore.collection("merchants");
    const transactionsRef = firestore.collection("transactions");

    try {
      dispatch(asyncActionStart());

      let querySnap = await accountRef
        .doc(account)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let group = doc.data().group;

            return transactionsRef
              .where("transactionDateTime", ">=", reportStartDate)
              .where("transactionDateTime", "<=", reportEndDate)
              .where("group", "==", group)
              .where("transactionType", "==", "Sale")
              .where("transactionStatus", "==", "Successful")
              .orderBy("transactionDateTime")
              .get();
          } else {
            return (querySnap = {
              docs: [],
            });
          }
        });

      let transactions = [];

      if (querySnap.docs.length === 0) {
        dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
        dispatch(asyncActionFinish());
        return querySnap;
      }

      for (let i = 0; i < querySnap.docs.length; i++) {
        let transaction = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        if (isVisibleRecord(transaction)) {
          transactions.push(transaction);
        }
      }

      dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const groupReportByCategory = (values) => async (dispatch, getState) => {
  const account = values.account;
  const reportStartDate = moment(values.reportStartDate)
    .startOf("day")
    .toDate(); // set to 12:00 am today
  const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");
  const accountRef = firestore.collection("merchants");

  try {
    dispatch(asyncActionStart());

    let transactions = await accountRef
      .doc(account)
      .get()
      .then((doc) => {
        console.log("doc.exists", doc.exists);

        if (doc.exists) {
          const group = doc.data().group;

          return transactionsRef
            .where("transactionDateTime", ">=", reportStartDate)
            .where("transactionDateTime", "<=", reportEndDate)
            .where("transactionType", "==", "Sale")
            .where("group", "==", group)
            .where("transactionStatus", "==", "Successful")
            .orderBy("transactionDateTime")
            .get()
            .then(function (querySnapshot) {
              const result = querySnapshot.docs
                .filter((doc) => isVisibleRecord(doc.data()))
                .map((doc) => {
                  return {
                    saleType: doc.data().saleType,
                    provider: doc.data().provider,
                    transactionAmount: doc.data().transactionAmount,
                  };
                })
                .reduce(
                  function (arr, doc) {
                    if (!(doc.saleType in arr))
                      arr.__array.push((arr[doc.saleType] = doc));
                    else {
                      arr[doc.saleType].transactionAmount += parseFloat(
                        doc.transactionAmount
                      )
                        ? parseFloat(doc.transactionAmount)
                        : 0;
                    }
                    return arr;
                  },
                  {
                    __array: [],
                  }
                );

              return result.__array;
            });
        } else {
          return (transactions = []);
        }
      });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const cachetReportByCategory =
  (values) => async (dispatch, getState) => {
    const reportStartDate = moment(values.reportStartDate)
      .startOf("day")
      .toDate(); // set to 12:00 am today
    const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

    const firestore = firebase.firestore();

    const transactionsRef = firestore.collection("transactions");

    try {
      dispatch(asyncActionStart());

      let transactions = await transactionsRef
        .where("transactionDateTime", ">=", reportStartDate)
        .where("transactionDateTime", "<=", reportEndDate)
        .where("transactionType", "==", "Sale")
        .where("transactionStatus", "==", "Successful")
        .orderBy("transactionDateTime")
        .get()
        .then(function (querySnapshot) {
          const result = querySnapshot.docs
            .map((doc) => {
              return {
                saleType: doc.data().saleType,
                transactionAmount: doc.data().transactionAmount,
              };
            })
            .reduce(
              function (arr, doc) {
                if (!(doc.saleType in arr))
                  arr.__array.push((arr[doc.saleType] = doc));
                else {
                  arr[doc.saleType].transactionAmount += parseFloat(
                    doc.transactionAmount
                  )
                    ? parseFloat(doc.transactionAmount)
                    : 0;
                }
                return arr;
              },
              {
                __array: [],
              }
            );

          return result.__array;
        });

      dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const groupReportByDate = (values) => async (dispatch, getState) => {
  const account = values.account;
  const reportStartDate = moment(values.reportStartDate)
    .startOf("day")
    .toDate(); // set to 12:00 am today
  const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");
  const accountRef = firestore.collection("merchants");

  try {
    dispatch(asyncActionStart());

    // let query = transactionsRef
    //   .where("transactionDateTime", ">=", reportStartDate)
    //   .where("transactionDateTime", "<=", reportEndDate)
    //   .where("outletId", "==", outletId)
    //   .where("transactionStatus", "==", "Successful")
    //   .orderBy("transactionDateTime");

    let transactions = await accountRef
      .doc(account)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let group = doc.data().group;

          return transactionsRef
            .where("transactionDateTime", ">=", reportStartDate)
            .where("transactionDateTime", "<=", reportEndDate)
            .where("group", "==", group)
            .where("transactionType", "==", "Sale")
            .where("transactionStatus", "==", "Successful")
            .orderBy("transactionDateTime")
            .get()
            .then(function (querySnapshot) {
              const result = querySnapshot.docs
                .filter((doc) => isVisibleRecord(doc.data()))
                .map((doc) => {
                  return {
                    transactionDateTime: moment(
                      doc.data().transactionDateTime.toDate()
                    ).format("YYYY-MM-DD"),
                    transactionAmount: doc.data().transactionAmount,
                  };
                })
                .reduce(
                  function (arr, doc) {
                    if (!(doc.transactionDateTime in arr))
                      arr.__array.push((arr[doc.transactionDateTime] = doc));
                    else {
                      arr[doc.transactionDateTime].transactionAmount +=
                        parseFloat(doc.transactionAmount)
                          ? parseFloat(doc.transactionAmount)
                          : 0;
                    }
                    return arr;
                  },
                  {
                    __array: [],
                  }
                );

              return result.__array;
            });
        } else {
          return (transactions = []);
        }
      });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const cachetReportByDate = (values) => async (dispatch, getState) => {
  const reportStartDate = moment(values.reportStartDate)
    .startOf("day")
    .toDate(); // set to 12:00 am today
  const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");

  try {
    dispatch(asyncActionStart());

    // let query = transactionsRef
    //   .where("transactionDateTime", ">=", reportStartDate)
    //   .where("transactionDateTime", "<=", reportEndDate)
    //   .where("outletId", "==", outletId)
    //   .where("transactionStatus", "==", "Successful")
    //   .orderBy("transactionDateTime");

    let transactions = await transactionsRef
      .where("transactionDateTime", ">=", reportStartDate)
      .where("transactionDateTime", "<=", reportEndDate)
      .where("transactionType", "==", "Sale")
      .where("transactionStatus", "==", "Successful")
      .orderBy("transactionDateTime")
      .get()
      .then(function (querySnapshot) {
        const result = querySnapshot.docs
          .map((doc) => {
            return {
              transactionDateTime: moment(
                doc.data().transactionDateTime.toDate()
              ).format("YYYY-MM-DD"),
              transactionAmount: doc.data().transactionAmount,
            };
          })
          .reduce(
            function (arr, doc) {
              if (!(doc.transactionDateTime in arr))
                arr.__array.push((arr[doc.transactionDateTime] = doc));
              else {
                arr[doc.transactionDateTime].transactionAmount += parseFloat(
                  doc.transactionAmount
                )
                  ? parseFloat(doc.transactionAmount)
                  : 0;
              }
              return arr;
            },
            {
              __array: [],
            }
          );

        return result.__array;
      });

    dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

export const getCachetTransactionsForDashboard =
  (values) => async (dispatch, getState) => {
    const reportStartDate = moment(values.reportStartDate)
      .startOf("day")
      .toDate(); // set to 12:00 am today
    const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

    const firestore = firebase.firestore();

    const transactionsRef = firestore.collection("transactions");

    try {
      dispatch(asyncActionStart());

      let querySnap = await transactionsRef
        .where("transactionDateTime", ">=", reportStartDate)
        .where("transactionDateTime", "<=", reportEndDate)
        .where("transactionType", "==", "Sale")
        .where("transactionStatus", "==", "Successful")
        .orderBy("transactionDateTime")
        .get();

      let transactions = [];

      if (querySnap.docs.length === 0) {
        dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
        dispatch(asyncActionFinish());
        return querySnap;
      }

      for (let i = 0; i < querySnap.docs.length; i++) {
        let transaction = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        transactions.push(transaction);
      }

      dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const getPrepaidPlusTransactionsForDashboard =
  (values) => async (dispatch, getState) => {
    const reportStartDate = moment(values.reportStartDate)
      .startOf("day")
      .toDate(); // set to 12:00 am today
    const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

    const firestore = firebase.firestore();

    const transactionsRef = firestore.collection("transactions");

    try {
      dispatch(asyncActionStart());

      let querySnap = await transactionsRef
        .where("transactionDateTime", ">=", reportStartDate)
        .where("transactionDateTime", "<=", reportEndDate)
        .where("transactionType", "==", "Sale")
        .where("transactionStatus", "==", "Successful")
        .orderBy("transactionDateTime")
        .get();

      let transactions = [];

      if (querySnap.docs.length === 0) {
        dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
        dispatch(asyncActionFinish());
        return querySnap;
      }

      for (let i = 0; i < querySnap.docs.length; i++) {
        let transaction = {
          ...querySnap.docs[i].data(),
          id: querySnap.docs[i].id,
        };
        transactions.push(transaction);
      }

      dispatch({ type: FETCH_TRANSACTIONS, payload: { transactions } });
      dispatch(asyncActionFinish());
      return querySnap;
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };

export const sendReportByMail = (values) => async (dispatch, getState) => {
  const reportStartDate = moment(values.reportStartDate)
    .startOf("day")
    .toDate(); // set to 12:00 am today
  const reportEndDate = moment(values.reportEndDate).endOf("day").toDate(); // set to 23:59 pm today

  const firestore = firebase.firestore();

  const transactionsRef = firestore.collection("transactions");

  try {
    dispatch(asyncActionStart());

    dispatch(asyncActionFinish());
    //return querySnap;
  } catch (error) {
    console.log(error);
    dispatch(asyncActionError());
  }
};

/**
 * Fetches all merchants and calculates their total sales for the selected period.
 * Processes merchants in batches to avoid freezing the browser or hitting Firestore limits.
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 */
export const getWeeklyMerchantSalesForExport =
  (startDate, endDate) => async (dispatch) => {
    const firestore = firebase.firestore();

    // Convert dates to moment timestamps
    const startTs = moment(startDate).startOf("day").valueOf();
    const endTs = moment(endDate).endOf("day").valueOf();

    try {
      dispatch(asyncActionStart());

      // Fetch All Merchants
      const merchantsSnap = await firestore.collection("merchants").get();
      const allMerchants = merchantsSnap.docs.map((doc) => ({
        ...doc.data(),
        account: doc.id,
      }));

      // Fetch Districts and Build Lookup Map
      let districtLookup = {};
      try {
        const districtsSnap = await firestore
          .collection("botswana_districts")
          .get();

        districtsSnap.forEach((doc) => {
          const data = doc.data();
          const districtName = data.district;
          const places = data.places || {};

          // Add both keys and values from places object to lookup
          Object.keys(places).forEach((placeKey) => {
            const normalizedKey = placeKey.trim().toLowerCase();
            if (normalizedKey) {
              districtLookup[normalizedKey] = districtName;
            }
          });

          Object.values(places).forEach((placeValue) => {
            if (typeof placeValue === "string") {
              const normalizedValue = placeValue.trim().toLowerCase();
              if (normalizedValue) {
                districtLookup[normalizedValue] = districtName;
              }
            }
          });
        });
      } catch (error) {
        console.error("Error fetching districts collection:", error);
        // Continue with empty lookup - will default to "Unknown"
      }

      let finalResults = [];
      const BATCH_SIZE = 50;

      // Helper Function to fetch sales for a single merchant
      const fetchSalesForMerchant = async (merchant) => {
        try {
          const salesSnap = await firestore
            .collection("merchant_balance")
            .where("account", "==", merchant.account)
            .where("recordId", ">=", startTs)
            .where("recordId", "<=", endTs)
            .where("transactionType", "==", "Sale")
            .get();

          // Summation - Firebase v7 doesn't have .aggregate()
          let total = 0;
          salesSnap.forEach((doc) => {
            const amount = parseFloat(doc.data().transactionAmount || 0);
            total += amount;
          });

          // Lookup district from city
          const cityKey = (merchant.city || "").trim().toLowerCase();
          const district = districtLookup[cityKey] || "Unknown";

          return {
            account: merchant.account,
            name: merchant.name || "",
            district: district,
            city: merchant.city || "",
            group: merchant.group || "",
            salesTotal: total,
          };
        } catch (error) {
          console.error(
            `Error fetching sales for merchant ${merchant.account}:`,
            error
          );
          // Return merchant with zero sales if error occurs
          const cityKey = (merchant.city || "").trim().toLowerCase();
          const district = districtLookup[cityKey] || "Unknown";

          return {
            account: merchant.account,
            name: merchant.name || "",
            district: district,
            city: merchant.city || "",
            group: merchant.group || "",
            salesTotal: 0,
          };
        }
      };

      // Process merchants in batches
      for (let i = 0; i < allMerchants.length; i += BATCH_SIZE) {
        const chunk = allMerchants.slice(i, i + BATCH_SIZE);

        const chunkResults = await Promise.all(
          chunk.map((m) => fetchSalesForMerchant(m))
        );
        finalResults = [...finalResults, ...chunkResults];
      }

      // Generate and download Excel file
      await createWeeklyMerchantSalesExcelFile(
        finalResults,
        startDate,
        endDate
      );

      dispatch(closeModal());
      dispatch(asyncActionFinish());

      toastr.success(
        "Success",
        `Weekly Merchant Sales Report generated successfully with ${finalResults.length} merchants`
      );
    } catch (error) {
      console.error("Weekly Merchant Sales Report Error:", error);
      toastr.error("Error", "Failed to generate Weekly Merchant Sales Report");
      dispatch(closeModal());
      dispatch(asyncActionError());
    }
  };
